import merge from 'lodash.merge';
import { AdminAccountAuthorization } from '../client-domain.types';

export const baseAdminAccountAuthorization: AdminAccountAuthorization = {
  dateCreated: '2022-10-11T22:17:31.693Z',
  dateUpdated: '2024-02-07T00:08:17.691Z',
  all: false,
  clientIdRoleIds: {
    '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e': 1,
    '793b75b3-ff9c-4356-9409-7118ab421ebb': 1,
    '1b63163d-1aba-4944-bbc1-ebc495d9dc5c': 1,
    'd2776d2a-33ae-4f3b-8091-34cad2e69fdc': 1,
  },
  clients: [
    {
      all: true,
      id: '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
      merchants: [],
    },
    {
      all: false,
      id: '793b75b3-ff9c-4356-9409-7118ab421ebb',
      merchants: [
        {
          all: true,
          id: 'e92a8753-38e7-4318-86ba-ef903c585739',
          locations: [],
        },
        {
          all: true,
          id: '044faf38-c219-4ee4-923a-12de8a2af944',
          locations: [],
        },
        {
          all: true,
          id: '452cb9f7-bc2a-4c2e-94b7-4e5448f353bc',
          locations: [],
        },
        {
          all: true,
          id: '18d1da94-0672-4a84-93aa-1f927de223c8',
          locations: [],
        },
      ],
    },
    {
      all: false,
      id: 'd2776d2a-33ae-4f3b-8091-34cad2e69fdc',
      merchants: [
        {
          all: true,
          id: 'ad1ee977-9316-44fe-90c3-5aaa06fd4141',
          locations: [],
        },
      ],
    },
    {
      all: false,
      id: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      merchants: [
        {
          all: true,
          id: '238f878f-fe74-4e41-a838-0f799bc58662',
          locations: [],
        },
        {
          all: true,
          id: '941f60f6-15ec-4ec4-9fe5-c07352ce8125',
          locations: [],
        },
        {
          all: true,
          id: '73c25df9-b8d5-4d89-9944-dbbdc0c8a117',
          locations: [],
        },
        {
          all: true,
          id: '84ace984-71ec-4488-b7fd-cb7bc24a881c',
          locations: [],
        },
        {
          all: true,
          id: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
          locations: [],
        },
        {
          all: true,
          id: '9458ce51-e44a-451a-b8a3-beb15d1ddbaf',
          locations: [],
        },
        {
          all: true,
          id: '392eca08-00c7-4f81-ae98-f346a54fb867',
          locations: [],
        },
        {
          all: true,
          id: 'bfdaf49b-938f-46ff-9b47-f9620d994353',
          locations: [],
        },
        {
          all: true,
          id: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
          locations: [],
        },
        {
          all: true,
          id: '5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca',
          locations: [],
        },
        {
          all: true,
          id: '0d18d2b3-7de0-4e16-b68e-f28a92bb8737',
          locations: [],
        },
      ],
    },
  ],
  email: 'bobm@incentivio.com',
  locationIdClientIds: {},
};

export const users = {
  'abb87f82-b83c-4c57-8e2e-f51c08fa9cec': {
    adminAccountAuthorization: baseAdminAccountAuthorization,
    adminId: 'abb87f82-b83c-4c57-8e2e-f51c08fa9cec',
    email: 'bobm@incentivio.com',
    clientID: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    firstName: 'Bob',
    lastName: 'McCracken',
    merchantId: null,
    role: {
      id: 1,
      role: 'ADMIN',
      description: 'Admin Full Access',
      modules: [
        {
          id: 46,
          name: 'App Home Screen',
          description: 'Mobile Home Screen Configuration',
          order: 33,
          roleModulePermissions: [
            {
              id: 199,
              permission: 'VIEW_APP_HOME_CONFIG',
              description: 'View Mobile Home Screen Configuration',
              moduleID: 46,
              deleted: false,
              active: true,
            },
            {
              id: 200,
              permission: 'EDIT_APP_HOME_CONFIG',
              description: 'Edit Mobile Home Screen Configuration',
              moduleID: 46,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 45,
          name: 'Auto Tagger',
          description: 'Auto Tagger',
          order: 32,
          roleModulePermissions: [
            {
              id: 142,
              permission: 'UPDATE_SEGMENT',
              description: 'Update segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
            {
              id: 140,
              permission: 'VIEW_SEGMENT',
              description: 'View segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
            {
              id: 141,
              permission: 'CREATE_SEGMENT',
              description: 'Create segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
            {
              id: 143,
              permission: 'DELETE_SEGMENT',
              description: 'Delete segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 35,
          name: 'Survey',
          description: 'Survey',
          order: 9,
          roleModulePermissions: [
            {
              id: 89,
              permission: 'EDIT_SURVEY',
              description: 'Edit Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
            {
              id: 88,
              permission: 'VIEW_SURVEY',
              description: 'View Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
            {
              id: 90,
              permission: 'DELETE_SURVEY',
              description: 'Delete Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
            {
              id: 91,
              permission: 'CREATE_SURVEY',
              description: 'Create Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 37,
          name: 'Customers',
          description: 'Customers',
          order: 11,
          roleModulePermissions: [
            {
              id: 96,
              permission: 'VIEW_CUSTOMER',
              description: 'View Customer',
              moduleID: 37,
              deleted: false,
              active: true,
            },
            {
              id: 128,
              permission: 'MANAGE_CUSTOMER_SPECIAL_TAGS',
              description: 'Manage Special Tags (Incentivio only)',
              moduleID: 37,
              deleted: false,
              active: true,
            },
            {
              id: 128,
              permission: 'EDIT_CUSTOMER',
              description: 'Edit Customer',
              moduleID: 37,
              deleted: false,
              active: true,
            },
            {
              id: 128,
              permission: 'DELETE_CUSTOMER',
              description: 'Delete Customer',
              moduleID: 37,
              deleted: false,
              active: true,
            },
            {
              id: 158,
              permission: 'ATTACH_TRANSACTION_TO_USER',
              description: 'Attach Transaction to User',
              moduleID: 37,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 27,
          name: 'Roles',
          description: 'Roles',
          order: 24,
          roleModulePermissions: [
            {
              id: 48,
              permission: 'VIEW_ROLE',
              description: 'View Roles',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 47,
              permission: 'CREATE_ROLE',
              description: 'Create Role',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 49,
              permission: 'EDIT_ROLE',
              description: 'Edit Role',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 50,
              permission: 'DELETE_ROLE',
              description: 'Delete Role',
              moduleID: 27,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 9,
          name: 'Analytics',
          description: 'Analytics',
          order: 1,
          roleModulePermissions: [
            {
              id: 75,
              permission: 'VIEW_ORDERS',
              description: 'View Orders',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 76,
              permission: 'VIEW_DAILY_ORDERS_REPORT',
              description: 'View Daily Sales Report',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 19,
              permission: 'VIEW_DASHBOARD',
              description: 'View Dashboard',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 150,
              permission: 'VIEW_SALES_SUMMARY',
              description: 'View Sales Summary',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 198,
              permission: 'VIEW_EMAIL_INSIGHTS_REPORT',
              description: 'View Email Insights Report',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 130,
              permission: 'VIEW_GUEST_JOURNEY',
              description: 'View Guest Journey',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 169,
              permission: 'EDIT_GUEST_JOURNEY_SETTINGS',
              description: 'Edit Guest Journey Settings',
              moduleID: 9,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 24,
          name: 'Group',
          description: 'Group',
          order: 21,
          roleModulePermissions: [
            {
              id: 64,
              permission: 'VIEW_GROUP',
              description: 'View Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
            {
              id: 65,
              permission: 'EDIT_GROUP',
              description: 'Edit Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
            {
              id: 66,
              permission: 'DELETE_GROUP',
              description: 'Delete Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
            {
              id: 63,
              permission: 'CREATE_GROUP',
              description: 'Create Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 13,
          name: 'Offers',
          description: 'Offers',
          order: 3,
          roleModulePermissions: [
            {
              id: 8,
              permission: 'DISTRIBUTE_OFFERS',
              description: 'Distribute Offers',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 7,
              permission: 'EDIT_OFFER',
              description: 'Edit Offer',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 5,
              permission: 'CREATE_OFFER',
              description: 'Create Offer',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 6,
              permission: 'VIEW_OFFER',
              description: 'View Offers',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 9,
              permission: 'DELETE_OFFER',
              description: 'Delete Offer',
              moduleID: 13,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 38,
          name: 'Easy Order',
          description: 'Easy Order',
          order: 19,
          roleModulePermissions: [
            {
              id: 102,
              permission: 'CREATE_EASY_ORDER',
              description: 'Create Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
            {
              id: 101,
              permission: 'DELETE_EASY_ORDER',
              description: 'Delete Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
            {
              id: 99,
              permission: 'VIEW_EASY_ORDER',
              description: 'View Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
            {
              id: 100,
              permission: 'EDIT_EASY_ORDER',
              description: 'Edit Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 39,
          name: 'Promo Code',
          description: 'Promo Code',
          order: 28,
          roleModulePermissions: [
            {
              id: 103,
              permission: 'CREATE_PROMO_CODE',
              description: 'Create Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
            {
              id: 104,
              permission: 'EDIT_PROMO_CODE',
              description: 'Edit Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
            {
              id: 105,
              permission: 'VIEW_PROMO_CODE',
              description: 'View Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
            {
              id: 106,
              permission: 'DELETE_PROMO_CODE',
              description: 'Delete Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 40,
          name: 'Gift Card',
          description: 'Gift Card',
          order: 29,
          roleModulePermissions: [
            {
              id: 116,
              permission: 'VIEW_GIFT_ANALYTICS',
              description: 'View Gift Analytics',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 112,
              permission: 'ACTIVATE_GIFT_CARD',
              description: 'Activate Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 117,
              permission: 'VIEW_GIFT_CARD_POOL_REPORT',
              description: 'View Gift Card Pool Report',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 114,
              permission: 'IMPORT_GIFT_CARDS',
              description: 'Import Gift Cards',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 120,
              permission: 'COMP_GIFT_CARD',
              description: 'Comp Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 110,
              permission: 'REMOVE_VALUE_GIFT_CARD',
              description: 'Remove Value From Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 118,
              permission: 'RESEND_GIFT_CARD_EMAIL',
              description: 'Resend Gift Card Email',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 111,
              permission: 'RESET_BALANCE_GIFT_CARD',
              description: 'Reset Gift Card Balance',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 113,
              permission: 'DEACTIVATE_GIFT_CARD',
              description: 'Deactivate Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 119,
              permission: 'COMP_ADD_VALUE_GIFT_CARD',
              description: 'Comp Add Value',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 115,
              permission: 'GENERATE_GIFT_CARDS',
              description: 'Generate Gift Cards',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 109,
              permission: 'VIEW_GIFT_CARD',
              description: 'View Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 36,
          name: 'Survey Question',
          description: 'Survey Question',
          order: 10,
          roleModulePermissions: [
            {
              id: 95,
              permission: 'CREATE_SURVEY_QUESTION',
              description: 'Create Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
            {
              id: 93,
              permission: 'EDIT_SURVEY_QUESTION',
              description: 'Edit Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
            {
              id: 92,
              permission: 'VIEW_SURVEY_QUESTION',
              description: 'View Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
            {
              id: 94,
              permission: 'DELETE_SURVEY_QUESTION',
              description: 'Delete Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 11,
          name: 'Campaign',
          description: 'Campaign',
          order: 2,
          roleModulePermissions: [
            {
              id: 15,
              permission: 'CREATE_CAMPAIGN',
              description: 'Create Campaign',
              moduleID: 11,
              deleted: false,
              active: true,
            },
            {
              id: 17,
              permission: 'EDIT_CAMPAIGN',
              description: 'Edit Campaign',
              moduleID: 11,
              deleted: false,
              active: true,
            },
            {
              id: 16,
              permission: 'VIEW_CAMPAIGN',
              description: 'View Campaigns',
              moduleID: 11,
              deleted: false,
              active: true,
            },
            {
              id: 18,
              permission: 'DELETE_CAMPAIGN',
              description: 'Delete Campaign',
              moduleID: 11,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 19,
          name: 'Store',
          description: 'Store',
          order: 12,
          roleModulePermissions: [
            {
              id: 27,
              permission: 'DELETE_STORE',
              description: 'Delete Store',
              moduleID: 19,
              deleted: false,
              active: true,
            },
            {
              id: 25,
              permission: 'VIEW_STORE',
              description: 'View Stores',
              moduleID: 19,
              deleted: false,
              active: true,
            },
            {
              id: 24,
              permission: 'CREATE_STORE',
              description: 'Create Store',
              moduleID: 19,
              deleted: false,
              active: true,
            },
            {
              id: 26,
              permission: 'EDIT_STORE',
              description: 'Edit Store',
              moduleID: 19,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 32,
          name: 'Store Ordering Setup',
          description: 'Store Ordering Setup',
          order: 13,
          roleModulePermissions: [
            {
              id: 80,
              permission: 'VIEW_STORE_ORDERING',
              description: 'View Store Ordering',
              moduleID: 32,
              deleted: false,
              active: true,
            },
            {
              id: 81,
              permission: 'EDIT_STORE_ORDERING',
              description: 'Edit Store Ordering',
              moduleID: 32,
              deleted: false,
              active: true,
            },
            {
              id: 82,
              permission: 'DELETE_STORE_ORDERING',
              description: 'Delete Store Ordering',
              moduleID: 32,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 33,
          name: 'Extensible Attributes',
          description: 'Extensible Attributes',
          order: 18,
          roleModulePermissions: [
            {
              id: 85,
              permission: 'EDIT_EXTENSIBLE_ATTRIBUTES',
              description: 'Edit Extensible Attributes',
              moduleID: 33,
              deleted: false,
              active: true,
            },
            {
              id: 86,
              permission: 'DELETE_EXTENSIBLE_ATTRIBUTES',
              description: 'Delete Extensible Attributes',
              moduleID: 33,
              deleted: false,
              active: true,
            },
            {
              id: 83,
              permission: 'VIEW_EXTENSIBLE_ATTRIBUTES',
              description: 'View Extensible Attributes',
              moduleID: 33,
              deleted: false,
              active: true,
            },
            {
              id: 84,
              permission: 'CREATE_EXTENSIBLE_ATTRIBUTES',
              description: 'Create Extensible Attributes',
              moduleID: 33,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 15,
          name: 'Persona',
          description: 'Persona',
          order: 6,
          roleModulePermissions: [
            {
              id: 58,
              permission: 'DELETE_PERSONA',
              description: 'Delete Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
            {
              id: 55,
              permission: 'CREATE_PERSONA',
              description: 'Create Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
            {
              id: 57,
              permission: 'EDIT_PERSONA',
              description: 'Edit Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
            {
              id: 56,
              permission: 'VIEW_PERSONA',
              description: 'View Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 21,
          name: 'Category',
          description: 'Category',
          order: 15,
          roleModulePermissions: [
            {
              id: 36,
              permission: 'CREATE_CATEGORY',
              description: 'Create Category',
              moduleID: 21,
              deleted: false,
              active: true,
            },
            {
              id: 37,
              permission: 'VIEW_CATEGORY',
              description: 'View Categories',
              moduleID: 21,
              deleted: false,
              active: true,
            },
            {
              id: 38,
              permission: 'EDIT_CATEGORY',
              description: 'Edit Category',
              moduleID: 21,
              deleted: false,
              active: true,
            },
            {
              id: 39,
              permission: 'DELETE_CATEGORY',
              description: 'Delete Category',
              moduleID: 21,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 25,
          name: 'Item',
          description: 'Item',
          order: 22,
          roleModulePermissions: [
            {
              id: 73,
              permission: 'EDIT_ITEM',
              description: 'Edit Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
            {
              id: 72,
              permission: 'VIEW_ITEM',
              description: 'View Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
            {
              id: 71,
              permission: 'CREATE_ITEM',
              description: 'Create Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
            {
              id: 74,
              permission: 'DELETE_ITEM',
              description: 'Delete Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 31,
          name: 'Merchant Ordering Setup',
          description: 'Merchant Ordering Setup',
          order: 8,
          roleModulePermissions: [
            {
              id: 78,
              permission: 'EDIT_MERCHANT_ORDERING',
              description: 'Edit Merchant Ordering',
              moduleID: 31,
              deleted: false,
              active: true,
            },
            {
              id: 79,
              permission: 'DELETE_MERCHANT_ORDERING',
              description: 'Delete Merchant Ordering',
              moduleID: 31,
              deleted: false,
              active: true,
            },
            {
              id: 77,
              permission: 'VIEW_MERCHANT_ORDERING',
              description: 'View Merchant Ordering',
              moduleID: 31,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 41,
          name: 'Menu Import',
          description: 'Menu Import',
          order: 30,
          roleModulePermissions: [
            {
              id: 122,
              permission: 'MENU_IMPORT_FOR_LOCATIONS',
              description: 'Menu Import for Locations',
              moduleID: 41,
              deleted: false,
              active: true,
            },
            {
              id: 123,
              permission: 'MENU_IMPORT_FOR_SINGLE_LOCATION',
              description: 'Menu Import for Single Location',
              moduleID: 41,
              deleted: false,
              active: true,
            },
            {
              id: 121,
              permission: 'VIEW_MENU_IMPORT_HISTORY',
              description: 'View Menu Import History',
              moduleID: 41,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 10,
          name: 'Program',
          description: 'Program',
          order: 2,
          roleModulePermissions: [
            {
              id: 28,
              permission: 'CREATE_PROGRAM',
              description: 'Create Program',
              moduleID: 10,
              deleted: false,
              active: true,
            },
            {
              id: 30,
              permission: 'EDIT_PROGRAM',
              description: 'Edit Program',
              moduleID: 10,
              deleted: false,
              active: true,
            },
            {
              id: 31,
              permission: 'DELETE_PROGRAM',
              description: 'Delete Program',
              moduleID: 10,
              deleted: false,
              active: true,
            },
            {
              id: 29,
              permission: 'VIEW_PROGRAM',
              description: 'View Programs',
              moduleID: 10,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 42,
          name: 'ACH Portal',
          description: 'ACH Portal',
          order: 31,
          roleModulePermissions: [
            {
              id: 125,
              permission: 'ACH_PORTAL_VIEW_POOL_ACCOUNT',
              description: 'ACH Portal View Pool Account',
              moduleID: 42,
              deleted: false,
              active: true,
            },
            {
              id: 126,
              permission: 'ACH_PORTAL_ENROLL_LOCATION',
              description: 'ACH Portal Enroll Location',
              moduleID: 42,
              deleted: false,
              active: true,
            },
            {
              id: 124,
              permission: 'ACH_PORTAL_ACCESS',
              description: 'ACH Portal Access',
              moduleID: 42,
              deleted: false,
              active: true,
            },
            {
              id: 127,
              permission: 'ACH_PORTAL_VIEW_TRANSACTION_HISTORY',
              description: 'ACH Portal View Transaction History',
              moduleID: 42,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 14,
          name: 'Loyalty',
          description: 'Loyalty',
          order: 4,
          roleModulePermissions: [
            {
              id: 11,
              permission: 'VIEW_LOYALTY_OFFER',
              description: 'View Loyalty Offers',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 10,
              permission: 'CREATE_LOYALTY_OFFER',
              description: 'Create Loyalty Offer',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 14,
              permission: 'DELETE_LOYALTY_OFFER',
              description: 'Delete Offer',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 12,
              permission: 'EDIT_LOYALTY_OFFER',
              description: 'Edit Loyalty Offer',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 13,
              permission: 'DISTRIBUTE_LOYALTY_OFFERS',
              description: 'Distribute Loyalty Offers',
              moduleID: 14,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 17,
          name: 'Merchant',
          description: 'Merchant',
          order: 7,
          roleModulePermissions: [
            {
              id: 22,
              permission: 'EDIT_MERCHANT',
              description: 'Edit Merchant',
              moduleID: 17,
              deleted: false,
              active: true,
            },
            {
              id: 23,
              permission: 'DELETE_MERCHANT',
              description: 'Delete Merchant',
              moduleID: 17,
              deleted: false,
              active: true,
            },
            {
              id: 20,
              permission: 'CREATE_MERCHANT',
              description: 'Create Merchant',
              moduleID: 17,
              deleted: false,
              active: true,
            },
            {
              id: 21,
              permission: 'VIEW_MERCHANT',
              description: 'View Merchants',
              moduleID: 17,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 22,
          name: 'Brand',
          description: 'Brand',
          order: 17,
          roleModulePermissions: [
            {
              id: 34,
              permission: 'EDIT_BRAND',
              description: 'Edit Brand',
              moduleID: 22,
              deleted: false,
              active: true,
            },
            {
              id: 32,
              permission: 'CREATE_BRAND',
              description: 'Create Brand',
              moduleID: 22,
              deleted: false,
              active: true,
            },
            {
              id: 33,
              permission: 'VIEW_BRAND',
              description: 'View Brands',
              moduleID: 22,
              deleted: false,
              active: true,
            },
            {
              id: 35,
              permission: 'DELETE_BRAND',
              description: 'Delete Brand',
              moduleID: 22,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 44,
          name: 'Payments',
          description: 'Payments',
          order: 31,
          roleModulePermissions: [
            {
              id: 137,
              permission: 'VIEW_TRANSACTIONS',
              description: 'View Payment Transactions',
              moduleID: 44,
              active: true,
              deleted: false,
            },
            {
              id: 139,
              permission: 'VIEW_REPORTS',
              description: 'View payment reports',
              moduleID: 44,
              active: true,
              deleted: false,
            },
            {
              id: 136,
              permission: 'CREATE_ACCOUNTS',
              description: 'Create payment accounts',
              moduleID: 44,
              active: true,
              deleted: false,
            },
            {
              id: 133,
              permission: 'REFUND_ORDERS',
              description: 'Refund Orders',
              moduleID: 44,
              active: true,
              deleted: false,
            },
            {
              id: 135,
              permission: 'VIEW_ACCOUNTS',
              description: 'View payment accounts',
              moduleID: 44,
              active: true,
              deleted: false,
            },
          ],
          allPermissions: null,
          active: true,
          deleted: false,
        },
        {
          id: 34,
          name: 'Support',
          description: 'Support',
          order: 27,
          roleModulePermissions: [
            {
              id: 87,
              permission: 'VIEW_SUPPORT',
              description: 'View Support',
              moduleID: 34,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 16,
          name: 'Beacon',
          description: 'Beacon',
          order: 6,
          roleModulePermissions: [
            {
              id: 51,
              permission: 'CREATE_BEACON',
              description: 'Create Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
            {
              id: 52,
              permission: 'EDIT_BEACON',
              description: 'Edit Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
            {
              id: 53,
              permission: 'DELETE_BEACON',
              description: 'Delete Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
            {
              id: 54,
              permission: 'VIEW_BEACON',
              description: 'View Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 29,
          name: 'Loyalty Transaction',
          description: 'Loyalty Transaction',
          order: 26,
          roleModulePermissions: [
            {
              id: 42,
              permission: 'DELETE_LOYALTY_TRANSACTION',
              description: 'Delete Loyalty Transaction',
              moduleID: 29,
              deleted: false,
              active: true,
            },
            {
              id: 40,
              permission: 'VIEW_LOYALTY_TRANSACTION',
              description: 'View Loyalty Transactions',
              moduleID: 29,
              deleted: false,
              active: true,
            },
            {
              id: 41,
              permission: 'EDIT_LOYALTY_TRANSACTION',
              description: 'Edit Loyalty Transaction',
              moduleID: 29,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 26,
          name: 'Users',
          description: 'Users',
          order: 23,
          roleModulePermissions: [
            {
              id: 46,
              permission: 'DELETE_USER',
              description: 'Delete User',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 44,
              permission: 'VIEW_USER',
              description: 'View Users',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 43,
              permission: 'CREATE_USER',
              description: 'Create User',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 45,
              permission: 'EDIT_USER',
              description: 'Edit User',
              moduleID: 26,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 23,
          name: 'Menu',
          description: 'Menu',
          order: 20,
          roleModulePermissions: [
            {
              id: 61,
              permission: 'EDIT_MENU',
              description: 'Edit Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 107,
              permission: 'MENU_BUILDER',
              description: 'Menu Builder',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 62,
              permission: 'DELETE_MENU',
              description: 'Delete Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 59,
              permission: 'CREATE_MENU',
              description: 'Create Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 108,
              permission: 'CACHE_MENU',
              description: 'Cache Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 60,
              permission: 'VIEW_MENU',
              description: 'View Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 140,
              permission: 'VIEW_BULK_IMAGE_UPLOADS',
              description: 'View bulk image uploads',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 141,
              permission: 'CREATE_BULK_IMAGE_UPLOADS',
              description: 'Create bulk image uploads',
              moduleID: 23,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 12,
          name: 'Messages',
          description: 'Messages',
          order: 3,
          roleModulePermissions: [
            {
              id: 4,
              permission: 'DELETE_MESSAGE',
              description: 'Delete Message',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 129,
              permission: 'CONFIGURE_CLIENT',
              description: 'Configure Client (Incentivio only)',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 3,
              permission: 'EDIT_MESSAGE',
              description: 'Edit Message',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 1,
              permission: 'CREATE_MESSAGE',
              description: 'Create Message',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 2,
              permission: 'VIEW_MESSAGE',
              description: 'View Messages',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 151,
              permission: 'VIEW_EMAIL_TEMPLATES',
              description: 'View Email Templates',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 152,
              permission: 'DELETE_EMAIL_TEMPLATES',
              description: 'Delete Email Templates',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 153,
              permission: 'CREATE_EDIT_EMAIL_TEMPLATES',
              description: 'Create And Edit Email Templates',
              moduleID: 44,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
      ],
      deleted: false,
      active: true,
    },
    status: 'VERIFIED',
    storeIds: null,
    reach:
      '["1b63163d-1aba-4944-bbc1-ebc495d9dc5c;7f3ffb13-7c1c-4909-9efb-b067b1728f12;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;84ace984-71ec-4488-b7fd-cb7bc24a881c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;9458ce51-e44a-451a-b8a3-beb15d1ddbaf;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;4c4ade61-7973-46f0-820f-4bf5bc783e0c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca;*"]',
    hasEntireClientReach: true,
    deleted: false,
  },
  'b826eaae-ea4a-49d1-80fa-53ef65a61c03': {
    adminAccountAuthorization: {
      dateCreated: '2022-10-11T22:17:31.693Z',
      dateUpdated: '2023-08-24T11:57:06.952Z',
      all: false,
      clientIdRoleIds: {
        '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e': 1,
        'f40b3afb-1cb9-44c0-8c68-80544ad5e5ae': 27,
        '324b82cf-abef-4d8d-b28b-627cbfac3bad': 1,
        '793b75b3-ff9c-4356-9409-7118ab421ebb': 1,
        '1b63163d-1aba-4944-bbc1-ebc495d9dc5c': 1,
      },
      clients: [
        {
          all: true,
          id: '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
          merchants: [],
        },
        {
          all: false,
          id: 'f40b3afb-1cb9-44c0-8c68-80544ad5e5ae',
          merchants: [
            {
              all: false,
              id: '009003da-eb2d-4d81-afdb-303ff1de4ff2',
              locations: [
                {
                  id: '365ff6c9-64a7-4ef2-b85e-aa22429f9f83',
                },
                {
                  id: '68d612d7-327f-4049-ae3a-55f1646ee3d7',
                },
              ],
            },
          ],
        },
        {
          all: false,
          id: '324b82cf-abef-4d8d-b28b-627cbfac3bad',
          merchants: [
            {
              all: false,
              id: 'e30b8a8f-8345-42c7-8e0f-e449db97c820',
              locations: [
                {
                  id: '954d6627-ca0b-43e5-aa29-e2042341bd2e',
                },
                {
                  id: 'd00669ae-49b6-4303-b158-f980894df9c9',
                },
              ],
            },
          ],
        },
        {
          all: false,
          id: '793b75b3-ff9c-4356-9409-7118ab421ebb',
          merchants: [
            {
              all: true,
              id: 'e92a8753-38e7-4318-86ba-ef903c585739',
              locations: [],
            },
            {
              all: true,
              id: '044faf38-c219-4ee4-923a-12de8a2af944',
              locations: [],
            },
            {
              all: true,
              id: '452cb9f7-bc2a-4c2e-94b7-4e5448f353bc',
              locations: [],
            },
            {
              all: true,
              id: '18d1da94-0672-4a84-93aa-1f927de223c8',
              locations: [],
            },
          ],
        },
        {
          all: false,
          id: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
          merchants: [
            {
              all: true,
              id: '238f878f-fe74-4e41-a838-0f799bc58662',
              locations: [],
            },
            {
              all: true,
              id: '73c25df9-b8d5-4d89-9944-dbbdc0c8a117',
              locations: [],
            },
            {
              all: true,
              id: '84ace984-71ec-4488-b7fd-cb7bc24a881c',
              locations: [],
            },
            {
              all: true,
              id: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
              locations: [],
            },
            {
              all: true,
              id: '9458ce51-e44a-451a-b8a3-beb15d1ddbaf',
              locations: [],
            },
            {
              all: true,
              id: '392eca08-00c7-4f81-ae98-f346a54fb867',
              locations: [],
            },
            {
              all: true,
              id: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
              locations: [],
            },
            {
              all: true,
              id: '5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca',
              locations: [],
            },
            {
              all: true,
              id: '0d18d2b3-7de0-4e16-b68e-f28a92bb8737',
              locations: [],
            },
          ],
        },
      ],
      email: 'arlene.r@aeturnum.com',
      locationIdClientIds: {
        '16854702-a4e8-4922-89f0-7b96b1a80cd1':
          '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
        '624f113e-4eaf-47a5-a29e-56c3fd5137b1':
          '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
        'd1d5ee1d-b264-4d7c-8f50-5ef22e66b5fe':
          '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
        'a35cbd11-c632-433b-8495-ec49ae40a44d':
          '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
        '3831ddf4-fa61-4eef-971c-f42b9f425c04':
          '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      },
    },
    adminId: 'b826eaae-ea4a-49d1-80fa-53ef65a61c03',
    email: 'arlene.r@aeturnum.com',
    clientID: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    firstName: 'Arlene',
    lastName: 'Ranasinghe11',
    merchantId: null,
    role: {
      id: 1,
      role: 'Incentivio Master Administrator',
      description: 'Admin Full Access (same name as on production)',
      modules: [
        {
          id: 35,
          name: 'Survey',
          description: 'Survey',
          order: 9,
          roleModulePermissions: [
            {
              id: 90,
              permission: 'DELETE_SURVEY',
              description: 'Delete Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
            {
              id: 91,
              permission: 'CREATE_SURVEY',
              description: 'Create Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
            {
              id: 88,
              permission: 'VIEW_SURVEY',
              description: 'View Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
            {
              id: 89,
              permission: 'EDIT_SURVEY',
              description: 'Edit Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 37,
          name: 'Customers',
          description: 'Customers',
          order: 11,
          roleModulePermissions: [
            {
              id: 128,
              permission: 'MANAGE_CUSTOMER_SPECIAL_TAGS',
              description: 'Manage Special Tags (Incentivio only)',
              moduleID: 37,
              deleted: false,
              active: true,
            },
            {
              id: 96,
              permission: 'VIEW_CUSTOMER',
              description: 'View Customer',
              moduleID: 37,
              deleted: false,
              active: true,
            },
            {
              id: 149,
              permission: 'DELETE_CUSTOMER',
              description: 'Delete a customer account',
              moduleID: 37,
              deleted: false,
              active: true,
            },
            {
              id: 134,
              permission: 'EDIT_CUSTOMER',
              description: 'Edit Customer',
              moduleID: 37,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 27,
          name: 'Roles',
          description: 'Roles',
          order: 24,
          roleModulePermissions: [
            {
              id: 49,
              permission: 'EDIT_ROLE',
              description: 'Edit Role',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 47,
              permission: 'CREATE_ROLE',
              description: 'Create Role',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 48,
              permission: 'VIEW_ROLE',
              description: 'View Roles',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 145,
              permission: 'MANAGE_ROLE_INCENTIVIO',
              description: 'Manage Incentivio roles',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 50,
              permission: 'DELETE_ROLE',
              description: 'Delete Role',
              moduleID: 27,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 9,
          name: 'Analytics',
          description: 'Analytics',
          order: 1,
          roleModulePermissions: [
            {
              id: 150,
              permission: 'VIEW_SALES_SUMMARY',
              description: 'View Sales Summary',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 19,
              permission: 'VIEW_DASHBOARD',
              description: 'View Dashboard',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 129,
              permission: 'VIEW_RECOMMENDATIONS',
              description: 'View Recommendations',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 76,
              permission: 'VIEW_DAILY_ORDERS_REPORT',
              description: 'View Daily Sales Report',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 75,
              permission: 'VIEW_ORDERS',
              description: 'View Orders',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 130,
              permission: 'VIEW_GUEST_JOURNEY',
              description: 'View Guest Journey',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 169,
              permission: 'EDIT_GUEST_JOURNEY_SETTINGS',
              description: 'Edit Guest Journey Settings',
              moduleID: 9,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 24,
          name: 'Group',
          description: 'Group',
          order: 21,
          roleModulePermissions: [
            {
              id: 64,
              permission: 'VIEW_GROUP',
              description: 'View Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
            {
              id: 65,
              permission: 'EDIT_GROUP',
              description: 'Edit Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
            {
              id: 66,
              permission: 'DELETE_GROUP',
              description: 'Delete Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
            {
              id: 63,
              permission: 'CREATE_GROUP',
              description: 'Create Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 13,
          name: 'Offers',
          description: 'Offers',
          order: 3,
          roleModulePermissions: [
            {
              id: 9,
              permission: 'DELETE_OFFER',
              description: 'Delete Offer',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 6,
              permission: 'VIEW_OFFER',
              description: 'View Offers',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 5,
              permission: 'CREATE_OFFER',
              description: 'Create Offer',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 8,
              permission: 'DISTRIBUTE_OFFERS',
              description: 'Distribute Offers',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 7,
              permission: 'EDIT_OFFER',
              description: 'Edit Offer',
              moduleID: 13,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 38,
          name: 'Easy Order',
          description: 'Easy Order',
          order: 19,
          roleModulePermissions: [
            {
              id: 101,
              permission: 'DELETE_EASY_ORDER',
              description: 'Delete Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
            {
              id: 99,
              permission: 'VIEW_EASY_ORDER',
              description: 'View Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
            {
              id: 102,
              permission: 'CREATE_EASY_ORDER',
              description: 'Create Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
            {
              id: 100,
              permission: 'EDIT_EASY_ORDER',
              description: 'Edit Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 43,
          name: 'Captcha',
          description: 'Captcha',
          order: 0,
          roleModulePermissions: [
            {
              id: 132,
              permission: 'ENABLE_CAPTCHA',
              description: 'Enable Captcha',
              moduleID: 43,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 39,
          name: 'Promo Code',
          description: 'Promo Code',
          order: 28,
          roleModulePermissions: [
            {
              id: 106,
              permission: 'DELETE_PROMO_CODE',
              description: 'Delete Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
            {
              id: 105,
              permission: 'VIEW_PROMO_CODE',
              description: 'View Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
            {
              id: 104,
              permission: 'EDIT_PROMO_CODE',
              description: 'Edit Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
            {
              id: 103,
              permission: 'CREATE_PROMO_CODE',
              description: 'Create Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 40,
          name: 'Gift Card',
          description: 'Gift Card',
          order: 29,
          roleModulePermissions: [
            {
              id: 114,
              permission: 'IMPORT_GIFT_CARDS',
              description: 'Import Gift Cards',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 115,
              permission: 'GENERATE_GIFT_CARDS',
              description: 'Generate Gift Cards',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 117,
              permission: 'VIEW_GIFT_CARD_POOL_REPORT',
              description: 'View Gift Card Pool Report',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 113,
              permission: 'DEACTIVATE_GIFT_CARD',
              description: 'Deactivate Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 111,
              permission: 'RESET_BALANCE_GIFT_CARD',
              description: 'Reset Gift Card Balance',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 110,
              permission: 'REMOVE_VALUE_GIFT_CARD',
              description: 'Remove Value From Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 112,
              permission: 'ACTIVATE_GIFT_CARD',
              description: 'Activate Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 119,
              permission: 'COMP_ADD_VALUE_GIFT_CARD',
              description: 'Comp Add Value',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 116,
              permission: 'VIEW_GIFT_ANALYTICS',
              description: 'View Gift Analytics',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 118,
              permission: 'RESEND_GIFT_CARD_EMAIL',
              description: 'Resend Gift Card Email',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 109,
              permission: 'VIEW_GIFT_CARD',
              description: 'View Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 120,
              permission: 'COMP_GIFT_CARD',
              description: 'Comp Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 36,
          name: 'Survey Question',
          description: 'Survey Question',
          order: 10,
          roleModulePermissions: [
            {
              id: 94,
              permission: 'DELETE_SURVEY_QUESTION',
              description: 'Delete Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
            {
              id: 95,
              permission: 'CREATE_SURVEY_QUESTION',
              description: 'Create Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
            {
              id: 93,
              permission: 'EDIT_SURVEY_QUESTION',
              description: 'Edit Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
            {
              id: 92,
              permission: 'VIEW_SURVEY_QUESTION',
              description: 'View Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 11,
          name: 'Campaign',
          description: 'Campaign',
          order: 2,
          roleModulePermissions: [
            {
              id: 15,
              permission: 'CREATE_CAMPAIGN',
              description: 'Create Campaign',
              moduleID: 11,
              deleted: false,
              active: true,
            },
            {
              id: 18,
              permission: 'DELETE_CAMPAIGN',
              description: 'Delete Campaign',
              moduleID: 11,
              deleted: false,
              active: true,
            },
            {
              id: 16,
              permission: 'VIEW_CAMPAIGN',
              description: 'View Campaigns',
              moduleID: 11,
              deleted: false,
              active: true,
            },
            {
              id: 17,
              permission: 'EDIT_CAMPAIGN',
              description: 'Edit Campaign',
              moduleID: 11,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 19,
          name: 'Store',
          description: 'Store',
          order: 12,
          roleModulePermissions: [
            {
              id: 26,
              permission: 'EDIT_STORE',
              description: 'Edit Store',
              moduleID: 19,
              deleted: false,
              active: true,
            },
            {
              id: 25,
              permission: 'VIEW_STORE',
              description: 'View Stores',
              moduleID: 19,
              deleted: false,
              active: true,
            },
            {
              id: 27,
              permission: 'DELETE_STORE',
              description: 'Delete Store',
              moduleID: 19,
              deleted: false,
              active: true,
            },
            {
              id: 24,
              permission: 'CREATE_STORE',
              description: 'Create Store',
              moduleID: 19,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 32,
          name: 'Store Ordering Setup',
          description: 'Store Ordering Setup',
          order: 13,
          roleModulePermissions: [
            {
              id: 81,
              permission: 'EDIT_STORE_ORDERING',
              description: 'Edit Store Ordering',
              moduleID: 32,
              deleted: false,
              active: true,
            },
            {
              id: 80,
              permission: 'VIEW_STORE_ORDERING',
              description: 'View Store Ordering',
              moduleID: 32,
              deleted: false,
              active: true,
            },
            {
              id: 82,
              permission: 'DELETE_STORE_ORDERING',
              description: 'Delete Store Ordering',
              moduleID: 32,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 45,
          name: 'Auto Tagger',
          description: 'Auto Tagger',
          order: 32,
          roleModulePermissions: [
            {
              id: 142,
              permission: 'UPDATE_SEGMENT',
              description: 'Update segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
            {
              id: 140,
              permission: 'VIEW_SEGMENT',
              description: 'View segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
            {
              id: 141,
              permission: 'CREATE_SEGMENT',
              description: 'Create segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
            {
              id: 143,
              permission: 'DELETE_SEGMENT',
              description: 'Delete segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 15,
          name: 'Persona',
          description: 'Persona',
          order: 6,
          roleModulePermissions: [
            {
              id: 57,
              permission: 'EDIT_PERSONA',
              description: 'Edit Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
            {
              id: 58,
              permission: 'DELETE_PERSONA',
              description: 'Delete Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
            {
              id: 56,
              permission: 'VIEW_PERSONA',
              description: 'View Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
            {
              id: 55,
              permission: 'CREATE_PERSONA',
              description: 'Create Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 21,
          name: 'Category',
          description: 'Category',
          order: 15,
          roleModulePermissions: [
            {
              id: 39,
              permission: 'DELETE_CATEGORY',
              description: 'Delete Category',
              moduleID: 21,
              deleted: false,
              active: true,
            },
            {
              id: 38,
              permission: 'EDIT_CATEGORY',
              description: 'Edit Category',
              moduleID: 21,
              deleted: false,
              active: true,
            },
            {
              id: 37,
              permission: 'VIEW_CATEGORY',
              description: 'View Categories',
              moduleID: 21,
              deleted: false,
              active: true,
            },
            {
              id: 36,
              permission: 'CREATE_CATEGORY',
              description: 'Create Category',
              moduleID: 21,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 25,
          name: 'Item',
          description: 'Item',
          order: 22,
          roleModulePermissions: [
            {
              id: 72,
              permission: 'VIEW_ITEM',
              description: 'View Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
            {
              id: 71,
              permission: 'CREATE_ITEM',
              description: 'Create Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
            {
              id: 73,
              permission: 'EDIT_ITEM',
              description: 'Edit Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
            {
              id: 74,
              permission: 'DELETE_ITEM',
              description: 'Delete Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 31,
          name: 'Merchant Ordering Setup',
          description: 'Merchant Ordering Setup',
          order: 8,
          roleModulePermissions: [
            {
              id: 77,
              permission: 'VIEW_MERCHANT_ORDERING',
              description: 'View Merchant Ordering',
              moduleID: 31,
              deleted: false,
              active: true,
            },
            {
              id: 79,
              permission: 'DELETE_MERCHANT_ORDERING',
              description: 'Delete Merchant Ordering',
              moduleID: 31,
              deleted: false,
              active: true,
            },
            {
              id: 78,
              permission: 'EDIT_MERCHANT_ORDERING',
              description: 'Edit Merchant Ordering',
              moduleID: 31,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 41,
          name: 'Menu Import',
          description: 'Menu Import',
          order: 30,
          roleModulePermissions: [
            {
              id: 123,
              permission: 'MENU_IMPORT_FOR_SINGLE_LOCATION',
              description: 'Menu Import for Single Location',
              moduleID: 41,
              deleted: false,
              active: true,
            },
            {
              id: 122,
              permission: 'MENU_IMPORT_FOR_LOCATIONS',
              description: 'Menu Import for Locations',
              moduleID: 41,
              deleted: false,
              active: true,
            },
            {
              id: 121,
              permission: 'VIEW_MENU_IMPORT_HISTORY',
              description: 'View Menu Import History',
              moduleID: 41,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 10,
          name: 'Program',
          description: 'Program',
          order: 2,
          roleModulePermissions: [
            {
              id: 31,
              permission: 'DELETE_PROGRAM',
              description: 'Delete Program',
              moduleID: 10,
              deleted: false,
              active: true,
            },
            {
              id: 30,
              permission: 'EDIT_PROGRAM',
              description: 'Edit Program',
              moduleID: 10,
              deleted: false,
              active: true,
            },
            {
              id: 29,
              permission: 'VIEW_PROGRAM',
              description: 'View Programs',
              moduleID: 10,
              deleted: false,
              active: true,
            },
            {
              id: 28,
              permission: 'CREATE_PROGRAM',
              description: 'Create Program',
              moduleID: 10,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 42,
          name: 'ACH Portal',
          description: 'ACH Portal',
          order: 31,
          roleModulePermissions: [
            {
              id: 126,
              permission: 'ACH_PORTAL_ENROLL_LOCATION',
              description: 'ACH Portal Enroll Location',
              moduleID: 42,
              deleted: false,
              active: true,
            },
            {
              id: 124,
              permission: 'ACH_PORTAL_ACCESS',
              description: 'ACH Portal Access',
              moduleID: 42,
              deleted: false,
              active: true,
            },
            {
              id: 125,
              permission: 'ACH_PORTAL_VIEW_POOL_ACCOUNT',
              description: 'ACH Portal View Pool Account',
              moduleID: 42,
              deleted: false,
              active: true,
            },
            {
              id: 127,
              permission: 'ACH_PORTAL_VIEW_TRANSACTION_HISTORY',
              description: 'ACH Portal View Transaction History',
              moduleID: 42,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 14,
          name: 'Loyalty',
          description: 'Loyalty',
          order: 4,
          roleModulePermissions: [
            {
              id: 12,
              permission: 'EDIT_LOYALTY_OFFER',
              description: 'Edit Loyalty Offer',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 13,
              permission: 'DISTRIBUTE_LOYALTY_OFFERS',
              description: 'Distribute Loyalty Offers',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 10,
              permission: 'CREATE_LOYALTY_OFFER',
              description: 'Create Loyalty Offer',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 14,
              permission: 'DELETE_LOYALTY_OFFER',
              description: 'Delete Offer',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 11,
              permission: 'VIEW_LOYALTY_OFFER',
              description: 'View Loyalty Offers',
              moduleID: 14,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 17,
          name: 'Merchant',
          description: 'Merchant',
          order: 7,
          roleModulePermissions: [
            {
              id: 23,
              permission: 'DELETE_MERCHANT',
              description: 'Delete Merchant',
              moduleID: 17,
              deleted: false,
              active: true,
            },
            {
              id: 21,
              permission: 'VIEW_MERCHANT',
              description: 'View Merchants',
              moduleID: 17,
              deleted: false,
              active: true,
            },
            {
              id: 22,
              permission: 'EDIT_MERCHANT',
              description: 'Edit Merchant',
              moduleID: 17,
              deleted: false,
              active: true,
            },
            {
              id: 20,
              permission: 'CREATE_MERCHANT',
              description: 'Create Merchant',
              moduleID: 17,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 22,
          name: 'Brand',
          description: 'Brand',
          order: 17,
          roleModulePermissions: [
            {
              id: 33,
              permission: 'VIEW_BRAND',
              description: 'View Brands',
              moduleID: 22,
              deleted: false,
              active: true,
            },
            {
              id: 34,
              permission: 'EDIT_BRAND',
              description: 'Edit Brand',
              moduleID: 22,
              deleted: false,
              active: true,
            },
            {
              id: 32,
              permission: 'CREATE_BRAND',
              description: 'Create Brand',
              moduleID: 22,
              deleted: false,
              active: true,
            },
            {
              id: 35,
              permission: 'DELETE_BRAND',
              description: 'Delete Brand',
              moduleID: 22,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 34,
          name: 'Support',
          description: 'Support',
          order: 27,
          roleModulePermissions: [
            {
              id: 87,
              permission: 'VIEW_SUPPORT',
              description: 'View Support',
              moduleID: 34,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 44,
          name: 'Payments',
          description: 'Payments',
          order: 31,
          roleModulePermissions: [
            {
              id: 146,
              permission: 'MANAGE_PAYMENTS_INCENTIVIO',
              description: 'Manage Incentivio payments',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 137,
              permission: 'VIEW_TRANSACTIONS',
              description: 'View Payment Transactions',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 136,
              permission: 'CREATE_ACCOUNTS',
              description: 'Create payment accounts',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 139,
              permission: 'VIEW_REPORTS',
              description: 'View payment reports',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 133,
              permission: 'REFUND_ORDERS',
              description: 'Refund Orders',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 135,
              permission: 'VIEW_ACCOUNTS',
              description: 'View payment accounts',
              moduleID: 44,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 33,
          name: 'Customer Tags',
          description: 'Customer Tags',
          order: 18,
          roleModulePermissions: [
            {
              id: 83,
              permission: 'VIEW_EXTENSIBLE_ATTRIBUTES',
              description: 'View Customer Tags',
              moduleID: 33,
              deleted: false,
              active: true,
            },
            {
              id: 85,
              permission: 'EDIT_EXTENSIBLE_ATTRIBUTES',
              description: 'Edit Customer Tags',
              moduleID: 33,
              deleted: false,
              active: true,
            },
            {
              id: 86,
              permission: 'DELETE_EXTENSIBLE_ATTRIBUTES',
              description: 'Delete Customer Tags',
              moduleID: 33,
              deleted: false,
              active: true,
            },
            {
              id: 84,
              permission: 'CREATE_EXTENSIBLE_ATTRIBUTES',
              description: 'Create Customer Tags',
              moduleID: 33,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 16,
          name: 'Beacon',
          description: 'Beacon',
          order: 6,
          roleModulePermissions: [
            {
              id: 53,
              permission: 'DELETE_BEACON',
              description: 'Delete Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
            {
              id: 51,
              permission: 'CREATE_BEACON',
              description: 'Create Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
            {
              id: 54,
              permission: 'VIEW_BEACON',
              description: 'View Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
            {
              id: 52,
              permission: 'EDIT_BEACON',
              description: 'Edit Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 29,
          name: 'Loyalty Transaction',
          description: 'Loyalty Transaction',
          order: 26,
          roleModulePermissions: [
            {
              id: 42,
              permission: 'DELETE_LOYALTY_TRANSACTION',
              description: 'Delete Loyalty Transaction',
              moduleID: 29,
              deleted: false,
              active: true,
            },
            {
              id: 40,
              permission: 'VIEW_LOYALTY_TRANSACTION',
              description: 'View Loyalty Transactions',
              moduleID: 29,
              deleted: false,
              active: true,
            },
            {
              id: 41,
              permission: 'EDIT_LOYALTY_TRANSACTION',
              description: 'Edit Loyalty Transaction',
              moduleID: 29,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 26,
          name: 'Users',
          description: 'Users',
          order: 23,
          roleModulePermissions: [
            {
              id: 144,
              permission: 'MANAGE_USER_INCENTIVIO',
              description: 'Manage Incentivio users',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 45,
              permission: 'EDIT_USER',
              description: 'Edit User',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 46,
              permission: 'DELETE_USER',
              description: 'Delete User',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 43,
              permission: 'CREATE_USER',
              description: 'Create User',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 44,
              permission: 'VIEW_USER',
              description: 'View Users',
              moduleID: 26,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 23,
          name: 'Menu',
          description: 'Menu',
          order: 20,
          roleModulePermissions: [
            {
              id: 107,
              permission: 'MENU_BUILDER',
              description: 'Menu Builder',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 147,
              permission: 'VIEW_BULK_IMAGE_UPLOADS',
              description: 'View bulk image uploads',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 62,
              permission: 'DELETE_MENU',
              description: 'Delete Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 148,
              permission: 'CREATE_BULK_IMAGE_UPLOADS',
              description: 'Create bulk image uploads',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 59,
              permission: 'CREATE_MENU',
              description: 'Create Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 108,
              permission: 'CACHE_MENU',
              description: 'Cache Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 60,
              permission: 'VIEW_MENU',
              description: 'View Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 61,
              permission: 'EDIT_MENU',
              description: 'Edit Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 12,
          name: 'Messages',
          description: 'Messages',
          order: 3,
          roleModulePermissions: [
            {
              id: 3,
              permission: 'EDIT_MESSAGE',
              description: 'Edit Message',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 1,
              permission: 'CREATE_MESSAGE',
              description: 'Create Message',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 4,
              permission: 'DELETE_MESSAGE',
              description: 'Delete Message',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 131,
              permission: 'CONFIGURE_CLIENT',
              description: 'Configure Client (Incentivio only)',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 2,
              permission: 'VIEW_MESSAGE',
              description: 'View Messages',
              moduleID: 12,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
      ],
      deleted: false,
      active: true,
    },
    status: 'VERIFIED',
    deleted: false,
    storeIds: ['3831ddf4-fa61-4eef-971c-f42b9f425c04'],
    reach:
      '["1b63163d-1aba-4944-bbc1-ebc495d9dc5c;238f878f-fe74-4e41-a838-0f799bc58662;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;73c25df9-b8d5-4d89-9944-dbbdc0c8a117;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;84ace984-71ec-4488-b7fd-cb7bc24a881c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;7f3ffb13-7c1c-4909-9efb-b067b1728f12;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;9458ce51-e44a-451a-b8a3-beb15d1ddbaf;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;392eca08-00c7-4f81-ae98-f346a54fb867;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;4c4ade61-7973-46f0-820f-4bf5bc783e0c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;0d18d2b3-7de0-4e16-b68e-f28a92bb8737;*"]',
    hasEntireClientReach: false,
  },
  super: {
    adminAccountAuthorization: {
      dateCreated: '2022-10-11T22:17:31.693Z',
      dateUpdated: '2023-08-24T11:57:06.952Z',
      all: true,
      clientIdRoleIds: {
        '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e': 1,
        'f40b3afb-1cb9-44c0-8c68-80544ad5e5ae': 27,
        '324b82cf-abef-4d8d-b28b-627cbfac3bad': 1,
        '793b75b3-ff9c-4356-9409-7118ab421ebb': 1,
        '1b63163d-1aba-4944-bbc1-ebc495d9dc5c': 1,
      },
      clients: [
        {
          all: true,
          id: '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
          merchants: [],
        },
        {
          all: false,
          id: 'f40b3afb-1cb9-44c0-8c68-80544ad5e5ae',
          merchants: [
            {
              all: false,
              id: '009003da-eb2d-4d81-afdb-303ff1de4ff2',
              locations: [
                {
                  id: '365ff6c9-64a7-4ef2-b85e-aa22429f9f83',
                },
                {
                  id: '68d612d7-327f-4049-ae3a-55f1646ee3d7',
                },
              ],
            },
          ],
        },
        {
          all: false,
          id: '324b82cf-abef-4d8d-b28b-627cbfac3bad',
          merchants: [
            {
              all: false,
              id: 'e30b8a8f-8345-42c7-8e0f-e449db97c820',
              locations: [
                {
                  id: '954d6627-ca0b-43e5-aa29-e2042341bd2e',
                },
                {
                  id: 'd00669ae-49b6-4303-b158-f980894df9c9',
                },
              ],
            },
          ],
        },
        {
          all: false,
          id: '793b75b3-ff9c-4356-9409-7118ab421ebb',
          merchants: [
            {
              all: true,
              id: 'e92a8753-38e7-4318-86ba-ef903c585739',
              locations: [],
            },
            {
              all: true,
              id: '044faf38-c219-4ee4-923a-12de8a2af944',
              locations: [],
            },
            {
              all: true,
              id: '452cb9f7-bc2a-4c2e-94b7-4e5448f353bc',
              locations: [],
            },
            {
              all: true,
              id: '18d1da94-0672-4a84-93aa-1f927de223c8',
              locations: [],
            },
          ],
        },
        {
          all: false,
          id: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
          merchants: [
            {
              all: true,
              id: '238f878f-fe74-4e41-a838-0f799bc58662',
              locations: [],
            },
            {
              all: true,
              id: '73c25df9-b8d5-4d89-9944-dbbdc0c8a117',
              locations: [],
            },
            {
              all: true,
              id: '84ace984-71ec-4488-b7fd-cb7bc24a881c',
              locations: [],
            },
            {
              all: true,
              id: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
              locations: [],
            },
            {
              all: true,
              id: '9458ce51-e44a-451a-b8a3-beb15d1ddbaf',
              locations: [],
            },
            {
              all: true,
              id: '392eca08-00c7-4f81-ae98-f346a54fb867',
              locations: [],
            },
            {
              all: true,
              id: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
              locations: [],
            },
            {
              all: true,
              id: '5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca',
              locations: [],
            },
            {
              all: true,
              id: '0d18d2b3-7de0-4e16-b68e-f28a92bb8737',
              locations: [],
            },
          ],
        },
      ],
      email: 'arlene.r@aeturnum.com',
      locationIdClientIds: {
        '16854702-a4e8-4922-89f0-7b96b1a80cd1':
          '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
        '624f113e-4eaf-47a5-a29e-56c3fd5137b1':
          '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
        'd1d5ee1d-b264-4d7c-8f50-5ef22e66b5fe':
          '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
        'a35cbd11-c632-433b-8495-ec49ae40a44d':
          '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
        '3831ddf4-fa61-4eef-971c-f42b9f425c04':
          '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      },
    },
    adminId: 'super',
    email: 'super@incentivio.com',
    clientID: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    firstName: 'Super',
    lastName: 'User',
    merchantId: null,
    role: {
      id: 1,
      role: 'Incentivio Master Administrator',
      description: 'Admin Full Access (same name as on production)',
      modules: [
        {
          id: 35,
          name: 'Survey',
          description: 'Survey',
          order: 9,
          roleModulePermissions: [
            {
              id: 90,
              permission: 'DELETE_SURVEY',
              description: 'Delete Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
            {
              id: 91,
              permission: 'CREATE_SURVEY',
              description: 'Create Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
            {
              id: 88,
              permission: 'VIEW_SURVEY',
              description: 'View Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
            {
              id: 89,
              permission: 'EDIT_SURVEY',
              description: 'Edit Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 37,
          name: 'Customers',
          description: 'Customers',
          order: 11,
          roleModulePermissions: [
            {
              id: 128,
              permission: 'MANAGE_CUSTOMER_SPECIAL_TAGS',
              description: 'Manage Special Tags (Incentivio only)',
              moduleID: 37,
              deleted: false,
              active: true,
            },
            {
              id: 96,
              permission: 'VIEW_CUSTOMER',
              description: 'View Customer',
              moduleID: 37,
              deleted: false,
              active: true,
            },
            {
              id: 149,
              permission: 'DELETE_CUSTOMER',
              description: 'Delete a customer account',
              moduleID: 37,
              deleted: false,
              active: true,
            },
            {
              id: 134,
              permission: 'EDIT_CUSTOMER',
              description: 'Edit Customer',
              moduleID: 37,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 27,
          name: 'Roles',
          description: 'Roles',
          order: 24,
          roleModulePermissions: [
            {
              id: 49,
              permission: 'EDIT_ROLE',
              description: 'Edit Role',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 47,
              permission: 'CREATE_ROLE',
              description: 'Create Role',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 48,
              permission: 'VIEW_ROLE',
              description: 'View Roles',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 145,
              permission: 'MANAGE_ROLE_INCENTIVIO',
              description: 'Manage Incentivio roles',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 50,
              permission: 'DELETE_ROLE',
              description: 'Delete Role',
              moduleID: 27,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 9,
          name: 'Analytics',
          description: 'Analytics',
          order: 1,
          roleModulePermissions: [
            {
              id: 150,
              permission: 'VIEW_SALES_SUMMARY',
              description: 'View Sales Summary',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 19,
              permission: 'VIEW_DASHBOARD',
              description: 'View Dashboard',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 129,
              permission: 'VIEW_RECOMMENDATIONS',
              description: 'View Recommendations',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 76,
              permission: 'VIEW_DAILY_ORDERS_REPORT',
              description: 'View Daily Sales Report',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 75,
              permission: 'VIEW_ORDERS',
              description: 'View Orders',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 130,
              permission: 'VIEW_GUEST_JOURNEY',
              description: 'View Guest Journey',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 169,
              permission: 'EDIT_GUEST_JOURNEY_SETTINGS',
              description: 'Edit Guest Journey Settings',
              moduleID: 9,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 24,
          name: 'Group',
          description: 'Group',
          order: 21,
          roleModulePermissions: [
            {
              id: 64,
              permission: 'VIEW_GROUP',
              description: 'View Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
            {
              id: 65,
              permission: 'EDIT_GROUP',
              description: 'Edit Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
            {
              id: 66,
              permission: 'DELETE_GROUP',
              description: 'Delete Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
            {
              id: 63,
              permission: 'CREATE_GROUP',
              description: 'Create Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 13,
          name: 'Offers',
          description: 'Offers',
          order: 3,
          roleModulePermissions: [
            {
              id: 9,
              permission: 'DELETE_OFFER',
              description: 'Delete Offer',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 6,
              permission: 'VIEW_OFFER',
              description: 'View Offers',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 5,
              permission: 'CREATE_OFFER',
              description: 'Create Offer',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 8,
              permission: 'DISTRIBUTE_OFFERS',
              description: 'Distribute Offers',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 7,
              permission: 'EDIT_OFFER',
              description: 'Edit Offer',
              moduleID: 13,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 38,
          name: 'Easy Order',
          description: 'Easy Order',
          order: 19,
          roleModulePermissions: [
            {
              id: 101,
              permission: 'DELETE_EASY_ORDER',
              description: 'Delete Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
            {
              id: 99,
              permission: 'VIEW_EASY_ORDER',
              description: 'View Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
            {
              id: 102,
              permission: 'CREATE_EASY_ORDER',
              description: 'Create Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
            {
              id: 100,
              permission: 'EDIT_EASY_ORDER',
              description: 'Edit Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 43,
          name: 'Captcha',
          description: 'Captcha',
          order: 0,
          roleModulePermissions: [
            {
              id: 132,
              permission: 'ENABLE_CAPTCHA',
              description: 'Enable Captcha',
              moduleID: 43,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 39,
          name: 'Promo Code',
          description: 'Promo Code',
          order: 28,
          roleModulePermissions: [
            {
              id: 106,
              permission: 'DELETE_PROMO_CODE',
              description: 'Delete Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
            {
              id: 105,
              permission: 'VIEW_PROMO_CODE',
              description: 'View Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
            {
              id: 104,
              permission: 'EDIT_PROMO_CODE',
              description: 'Edit Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
            {
              id: 103,
              permission: 'CREATE_PROMO_CODE',
              description: 'Create Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 40,
          name: 'Gift Card',
          description: 'Gift Card',
          order: 29,
          roleModulePermissions: [
            {
              id: 114,
              permission: 'IMPORT_GIFT_CARDS',
              description: 'Import Gift Cards',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 115,
              permission: 'GENERATE_GIFT_CARDS',
              description: 'Generate Gift Cards',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 117,
              permission: 'VIEW_GIFT_CARD_POOL_REPORT',
              description: 'View Gift Card Pool Report',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 113,
              permission: 'DEACTIVATE_GIFT_CARD',
              description: 'Deactivate Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 111,
              permission: 'RESET_BALANCE_GIFT_CARD',
              description: 'Reset Gift Card Balance',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 110,
              permission: 'REMOVE_VALUE_GIFT_CARD',
              description: 'Remove Value From Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 112,
              permission: 'ACTIVATE_GIFT_CARD',
              description: 'Activate Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 119,
              permission: 'COMP_ADD_VALUE_GIFT_CARD',
              description: 'Comp Add Value',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 116,
              permission: 'VIEW_GIFT_ANALYTICS',
              description: 'View Gift Analytics',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 118,
              permission: 'RESEND_GIFT_CARD_EMAIL',
              description: 'Resend Gift Card Email',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 109,
              permission: 'VIEW_GIFT_CARD',
              description: 'View Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 120,
              permission: 'COMP_GIFT_CARD',
              description: 'Comp Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 36,
          name: 'Survey Question',
          description: 'Survey Question',
          order: 10,
          roleModulePermissions: [
            {
              id: 94,
              permission: 'DELETE_SURVEY_QUESTION',
              description: 'Delete Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
            {
              id: 95,
              permission: 'CREATE_SURVEY_QUESTION',
              description: 'Create Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
            {
              id: 93,
              permission: 'EDIT_SURVEY_QUESTION',
              description: 'Edit Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
            {
              id: 92,
              permission: 'VIEW_SURVEY_QUESTION',
              description: 'View Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 11,
          name: 'Campaign',
          description: 'Campaign',
          order: 2,
          roleModulePermissions: [
            {
              id: 15,
              permission: 'CREATE_CAMPAIGN',
              description: 'Create Campaign',
              moduleID: 11,
              deleted: false,
              active: true,
            },
            {
              id: 18,
              permission: 'DELETE_CAMPAIGN',
              description: 'Delete Campaign',
              moduleID: 11,
              deleted: false,
              active: true,
            },
            {
              id: 16,
              permission: 'VIEW_CAMPAIGN',
              description: 'View Campaigns',
              moduleID: 11,
              deleted: false,
              active: true,
            },
            {
              id: 17,
              permission: 'EDIT_CAMPAIGN',
              description: 'Edit Campaign',
              moduleID: 11,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 19,
          name: 'Store',
          description: 'Store',
          order: 12,
          roleModulePermissions: [
            {
              id: 26,
              permission: 'EDIT_STORE',
              description: 'Edit Store',
              moduleID: 19,
              deleted: false,
              active: true,
            },
            {
              id: 25,
              permission: 'VIEW_STORE',
              description: 'View Stores',
              moduleID: 19,
              deleted: false,
              active: true,
            },
            {
              id: 27,
              permission: 'DELETE_STORE',
              description: 'Delete Store',
              moduleID: 19,
              deleted: false,
              active: true,
            },
            {
              id: 24,
              permission: 'CREATE_STORE',
              description: 'Create Store',
              moduleID: 19,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 32,
          name: 'Store Ordering Setup',
          description: 'Store Ordering Setup',
          order: 13,
          roleModulePermissions: [
            {
              id: 81,
              permission: 'EDIT_STORE_ORDERING',
              description: 'Edit Store Ordering',
              moduleID: 32,
              deleted: false,
              active: true,
            },
            {
              id: 80,
              permission: 'VIEW_STORE_ORDERING',
              description: 'View Store Ordering',
              moduleID: 32,
              deleted: false,
              active: true,
            },
            {
              id: 82,
              permission: 'DELETE_STORE_ORDERING',
              description: 'Delete Store Ordering',
              moduleID: 32,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 45,
          name: 'Auto Tagger',
          description: 'Auto Tagger',
          order: 32,
          roleModulePermissions: [
            {
              id: 142,
              permission: 'UPDATE_SEGMENT',
              description: 'Update segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
            {
              id: 140,
              permission: 'VIEW_SEGMENT',
              description: 'View segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
            {
              id: 141,
              permission: 'CREATE_SEGMENT',
              description: 'Create segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
            {
              id: 143,
              permission: 'DELETE_SEGMENT',
              description: 'Delete segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 15,
          name: 'Persona',
          description: 'Persona',
          order: 6,
          roleModulePermissions: [
            {
              id: 57,
              permission: 'EDIT_PERSONA',
              description: 'Edit Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
            {
              id: 58,
              permission: 'DELETE_PERSONA',
              description: 'Delete Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
            {
              id: 56,
              permission: 'VIEW_PERSONA',
              description: 'View Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
            {
              id: 55,
              permission: 'CREATE_PERSONA',
              description: 'Create Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 21,
          name: 'Category',
          description: 'Category',
          order: 15,
          roleModulePermissions: [
            {
              id: 39,
              permission: 'DELETE_CATEGORY',
              description: 'Delete Category',
              moduleID: 21,
              deleted: false,
              active: true,
            },
            {
              id: 38,
              permission: 'EDIT_CATEGORY',
              description: 'Edit Category',
              moduleID: 21,
              deleted: false,
              active: true,
            },
            {
              id: 37,
              permission: 'VIEW_CATEGORY',
              description: 'View Categories',
              moduleID: 21,
              deleted: false,
              active: true,
            },
            {
              id: 36,
              permission: 'CREATE_CATEGORY',
              description: 'Create Category',
              moduleID: 21,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 25,
          name: 'Item',
          description: 'Item',
          order: 22,
          roleModulePermissions: [
            {
              id: 72,
              permission: 'VIEW_ITEM',
              description: 'View Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
            {
              id: 71,
              permission: 'CREATE_ITEM',
              description: 'Create Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
            {
              id: 73,
              permission: 'EDIT_ITEM',
              description: 'Edit Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
            {
              id: 74,
              permission: 'DELETE_ITEM',
              description: 'Delete Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 31,
          name: 'Merchant Ordering Setup',
          description: 'Merchant Ordering Setup',
          order: 8,
          roleModulePermissions: [
            {
              id: 77,
              permission: 'VIEW_MERCHANT_ORDERING',
              description: 'View Merchant Ordering',
              moduleID: 31,
              deleted: false,
              active: true,
            },
            {
              id: 79,
              permission: 'DELETE_MERCHANT_ORDERING',
              description: 'Delete Merchant Ordering',
              moduleID: 31,
              deleted: false,
              active: true,
            },
            {
              id: 78,
              permission: 'EDIT_MERCHANT_ORDERING',
              description: 'Edit Merchant Ordering',
              moduleID: 31,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 41,
          name: 'Menu Import',
          description: 'Menu Import',
          order: 30,
          roleModulePermissions: [
            {
              id: 123,
              permission: 'MENU_IMPORT_FOR_SINGLE_LOCATION',
              description: 'Menu Import for Single Location',
              moduleID: 41,
              deleted: false,
              active: true,
            },
            {
              id: 122,
              permission: 'MENU_IMPORT_FOR_LOCATIONS',
              description: 'Menu Import for Locations',
              moduleID: 41,
              deleted: false,
              active: true,
            },
            {
              id: 121,
              permission: 'VIEW_MENU_IMPORT_HISTORY',
              description: 'View Menu Import History',
              moduleID: 41,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 10,
          name: 'Program',
          description: 'Program',
          order: 2,
          roleModulePermissions: [
            {
              id: 31,
              permission: 'DELETE_PROGRAM',
              description: 'Delete Program',
              moduleID: 10,
              deleted: false,
              active: true,
            },
            {
              id: 30,
              permission: 'EDIT_PROGRAM',
              description: 'Edit Program',
              moduleID: 10,
              deleted: false,
              active: true,
            },
            {
              id: 29,
              permission: 'VIEW_PROGRAM',
              description: 'View Programs',
              moduleID: 10,
              deleted: false,
              active: true,
            },
            {
              id: 28,
              permission: 'CREATE_PROGRAM',
              description: 'Create Program',
              moduleID: 10,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 42,
          name: 'ACH Portal',
          description: 'ACH Portal',
          order: 31,
          roleModulePermissions: [
            {
              id: 126,
              permission: 'ACH_PORTAL_ENROLL_LOCATION',
              description: 'ACH Portal Enroll Location',
              moduleID: 42,
              deleted: false,
              active: true,
            },
            {
              id: 124,
              permission: 'ACH_PORTAL_ACCESS',
              description: 'ACH Portal Access',
              moduleID: 42,
              deleted: false,
              active: true,
            },
            {
              id: 125,
              permission: 'ACH_PORTAL_VIEW_POOL_ACCOUNT',
              description: 'ACH Portal View Pool Account',
              moduleID: 42,
              deleted: false,
              active: true,
            },
            {
              id: 127,
              permission: 'ACH_PORTAL_VIEW_TRANSACTION_HISTORY',
              description: 'ACH Portal View Transaction History',
              moduleID: 42,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 14,
          name: 'Loyalty',
          description: 'Loyalty',
          order: 4,
          roleModulePermissions: [
            {
              id: 12,
              permission: 'EDIT_LOYALTY_OFFER',
              description: 'Edit Loyalty Offer',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 13,
              permission: 'DISTRIBUTE_LOYALTY_OFFERS',
              description: 'Distribute Loyalty Offers',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 10,
              permission: 'CREATE_LOYALTY_OFFER',
              description: 'Create Loyalty Offer',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 14,
              permission: 'DELETE_LOYALTY_OFFER',
              description: 'Delete Offer',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 11,
              permission: 'VIEW_LOYALTY_OFFER',
              description: 'View Loyalty Offers',
              moduleID: 14,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 17,
          name: 'Merchant',
          description: 'Merchant',
          order: 7,
          roleModulePermissions: [
            {
              id: 23,
              permission: 'DELETE_MERCHANT',
              description: 'Delete Merchant',
              moduleID: 17,
              deleted: false,
              active: true,
            },
            {
              id: 21,
              permission: 'VIEW_MERCHANT',
              description: 'View Merchants',
              moduleID: 17,
              deleted: false,
              active: true,
            },
            {
              id: 22,
              permission: 'EDIT_MERCHANT',
              description: 'Edit Merchant',
              moduleID: 17,
              deleted: false,
              active: true,
            },
            {
              id: 20,
              permission: 'CREATE_MERCHANT',
              description: 'Create Merchant',
              moduleID: 17,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 22,
          name: 'Brand',
          description: 'Brand',
          order: 17,
          roleModulePermissions: [
            {
              id: 33,
              permission: 'VIEW_BRAND',
              description: 'View Brands',
              moduleID: 22,
              deleted: false,
              active: true,
            },
            {
              id: 34,
              permission: 'EDIT_BRAND',
              description: 'Edit Brand',
              moduleID: 22,
              deleted: false,
              active: true,
            },
            {
              id: 32,
              permission: 'CREATE_BRAND',
              description: 'Create Brand',
              moduleID: 22,
              deleted: false,
              active: true,
            },
            {
              id: 35,
              permission: 'DELETE_BRAND',
              description: 'Delete Brand',
              moduleID: 22,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 34,
          name: 'Support',
          description: 'Support',
          order: 27,
          roleModulePermissions: [
            {
              id: 87,
              permission: 'VIEW_SUPPORT',
              description: 'View Support',
              moduleID: 34,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 44,
          name: 'Payments',
          description: 'Payments',
          order: 31,
          roleModulePermissions: [
            {
              id: 146,
              permission: 'MANAGE_PAYMENTS_INCENTIVIO',
              description: 'Manage Incentivio payments',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 137,
              permission: 'VIEW_TRANSACTIONS',
              description: 'View Payment Transactions',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 136,
              permission: 'CREATE_ACCOUNTS',
              description: 'Create payment accounts',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 139,
              permission: 'VIEW_REPORTS',
              description: 'View payment reports',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 133,
              permission: 'REFUND_ORDERS',
              description: 'Refund Orders',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 135,
              permission: 'VIEW_ACCOUNTS',
              description: 'View payment accounts',
              moduleID: 44,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 33,
          name: 'Customer Tags',
          description: 'Customer Tags',
          order: 18,
          roleModulePermissions: [
            {
              id: 83,
              permission: 'VIEW_EXTENSIBLE_ATTRIBUTES',
              description: 'View Customer Tags',
              moduleID: 33,
              deleted: false,
              active: true,
            },
            {
              id: 85,
              permission: 'EDIT_EXTENSIBLE_ATTRIBUTES',
              description: 'Edit Customer Tags',
              moduleID: 33,
              deleted: false,
              active: true,
            },
            {
              id: 86,
              permission: 'DELETE_EXTENSIBLE_ATTRIBUTES',
              description: 'Delete Customer Tags',
              moduleID: 33,
              deleted: false,
              active: true,
            },
            {
              id: 84,
              permission: 'CREATE_EXTENSIBLE_ATTRIBUTES',
              description: 'Create Customer Tags',
              moduleID: 33,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 16,
          name: 'Beacon',
          description: 'Beacon',
          order: 6,
          roleModulePermissions: [
            {
              id: 53,
              permission: 'DELETE_BEACON',
              description: 'Delete Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
            {
              id: 51,
              permission: 'CREATE_BEACON',
              description: 'Create Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
            {
              id: 54,
              permission: 'VIEW_BEACON',
              description: 'View Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
            {
              id: 52,
              permission: 'EDIT_BEACON',
              description: 'Edit Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 29,
          name: 'Loyalty Transaction',
          description: 'Loyalty Transaction',
          order: 26,
          roleModulePermissions: [
            {
              id: 42,
              permission: 'DELETE_LOYALTY_TRANSACTION',
              description: 'Delete Loyalty Transaction',
              moduleID: 29,
              deleted: false,
              active: true,
            },
            {
              id: 40,
              permission: 'VIEW_LOYALTY_TRANSACTION',
              description: 'View Loyalty Transactions',
              moduleID: 29,
              deleted: false,
              active: true,
            },
            {
              id: 41,
              permission: 'EDIT_LOYALTY_TRANSACTION',
              description: 'Edit Loyalty Transaction',
              moduleID: 29,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 26,
          name: 'Users',
          description: 'Users',
          order: 23,
          roleModulePermissions: [
            {
              id: 144,
              permission: 'MANAGE_USER_INCENTIVIO',
              description: 'Manage Incentivio users',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 45,
              permission: 'EDIT_USER',
              description: 'Edit User',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 46,
              permission: 'DELETE_USER',
              description: 'Delete User',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 43,
              permission: 'CREATE_USER',
              description: 'Create User',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 44,
              permission: 'VIEW_USER',
              description: 'View Users',
              moduleID: 26,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 23,
          name: 'Menu',
          description: 'Menu',
          order: 20,
          roleModulePermissions: [
            {
              id: 107,
              permission: 'MENU_BUILDER',
              description: 'Menu Builder',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 147,
              permission: 'VIEW_BULK_IMAGE_UPLOADS',
              description: 'View bulk image uploads',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 62,
              permission: 'DELETE_MENU',
              description: 'Delete Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 148,
              permission: 'CREATE_BULK_IMAGE_UPLOADS',
              description: 'Create bulk image uploads',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 59,
              permission: 'CREATE_MENU',
              description: 'Create Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 108,
              permission: 'CACHE_MENU',
              description: 'Cache Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 60,
              permission: 'VIEW_MENU',
              description: 'View Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 61,
              permission: 'EDIT_MENU',
              description: 'Edit Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 12,
          name: 'Messages',
          description: 'Messages',
          order: 3,
          roleModulePermissions: [
            {
              id: 3,
              permission: 'EDIT_MESSAGE',
              description: 'Edit Message',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 1,
              permission: 'CREATE_MESSAGE',
              description: 'Create Message',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 4,
              permission: 'DELETE_MESSAGE',
              description: 'Delete Message',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 131,
              permission: 'CONFIGURE_CLIENT',
              description: 'Configure Client (Incentivio only)',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 2,
              permission: 'VIEW_MESSAGE',
              description: 'View Messages',
              moduleID: 12,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
      ],
      deleted: false,
      active: true,
    },
    status: 'VERIFIED',
    deleted: false,
    storeIds: ['3831ddf4-fa61-4eef-971c-f42b9f425c04'],
    reach:
      '["1b63163d-1aba-4944-bbc1-ebc495d9dc5c;238f878f-fe74-4e41-a838-0f799bc58662;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;73c25df9-b8d5-4d89-9944-dbbdc0c8a117;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;84ace984-71ec-4488-b7fd-cb7bc24a881c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;7f3ffb13-7c1c-4909-9efb-b067b1728f12;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;9458ce51-e44a-451a-b8a3-beb15d1ddbaf;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;392eca08-00c7-4f81-ae98-f346a54fb867;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;4c4ade61-7973-46f0-820f-4bf5bc783e0c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;0d18d2b3-7de0-4e16-b68e-f28a92bb8737;*"]',
    hasEntireClientReach: false,
  },
  client: {
    adminAccountAuthorization: {
      dateCreated: '2022-10-11T22:17:31.693Z',
      dateUpdated: '2023-08-24T11:57:06.952Z',
      all: false,
      clientIdRoleIds: {
        '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e': 1,
        'f40b3afb-1cb9-44c0-8c68-80544ad5e5ae': 27,
        '324b82cf-abef-4d8d-b28b-627cbfac3bad': 1,
        '793b75b3-ff9c-4356-9409-7118ab421ebb': 1,
        '1b63163d-1aba-4944-bbc1-ebc495d9dc5c': 1,
      },
      clients: [
        {
          all: true,
          id: '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
          merchants: [],
        },
        {
          all: true,
          id: 'f40b3afb-1cb9-44c0-8c68-80544ad5e5ae',
          merchants: [
            {
              all: false,
              id: '009003da-eb2d-4d81-afdb-303ff1de4ff2',
              locations: [
                {
                  id: '365ff6c9-64a7-4ef2-b85e-aa22429f9f83',
                },
                {
                  id: '68d612d7-327f-4049-ae3a-55f1646ee3d7',
                },
              ],
            },
          ],
        },
        {
          all: true,
          id: '324b82cf-abef-4d8d-b28b-627cbfac3bad',
          merchants: [
            {
              all: false,
              id: 'e30b8a8f-8345-42c7-8e0f-e449db97c820',
              locations: [
                {
                  id: '954d6627-ca0b-43e5-aa29-e2042341bd2e',
                },
                {
                  id: 'd00669ae-49b6-4303-b158-f980894df9c9',
                },
              ],
            },
          ],
        },
        {
          all: true,
          id: '793b75b3-ff9c-4356-9409-7118ab421ebb',
          merchants: [
            {
              all: true,
              id: 'e92a8753-38e7-4318-86ba-ef903c585739',
              locations: [],
            },
            {
              all: true,
              id: '044faf38-c219-4ee4-923a-12de8a2af944',
              locations: [],
            },
            {
              all: true,
              id: '452cb9f7-bc2a-4c2e-94b7-4e5448f353bc',
              locations: [],
            },
            {
              all: true,
              id: '18d1da94-0672-4a84-93aa-1f927de223c8',
              locations: [],
            },
          ],
        },
        {
          all: true,
          id: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
          merchants: [
            {
              all: true,
              id: '238f878f-fe74-4e41-a838-0f799bc58662',
              locations: [],
            },
            {
              all: true,
              id: '73c25df9-b8d5-4d89-9944-dbbdc0c8a117',
              locations: [],
            },
            {
              all: true,
              id: '84ace984-71ec-4488-b7fd-cb7bc24a881c',
              locations: [],
            },
            {
              all: true,
              id: '7f3ffb13-7c1c-4909-9efb-b067b1728f12',
              locations: [],
            },
            {
              all: true,
              id: '9458ce51-e44a-451a-b8a3-beb15d1ddbaf',
              locations: [],
            },
            {
              all: true,
              id: '392eca08-00c7-4f81-ae98-f346a54fb867',
              locations: [],
            },
            {
              all: true,
              id: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
              locations: [],
            },
            {
              all: true,
              id: '5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca',
              locations: [],
            },
            {
              all: true,
              id: '0d18d2b3-7de0-4e16-b68e-f28a92bb8737',
              locations: [],
            },
          ],
        },
      ],
      email: 'client@incentivio.com',
      locationIdClientIds: {
        '16854702-a4e8-4922-89f0-7b96b1a80cd1':
          '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
        '624f113e-4eaf-47a5-a29e-56c3fd5137b1':
          '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
        'd1d5ee1d-b264-4d7c-8f50-5ef22e66b5fe':
          '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
        'a35cbd11-c632-433b-8495-ec49ae40a44d':
          '4ea169b8-f6a3-4819-9f71-4e3566c2aa5e',
        '3831ddf4-fa61-4eef-971c-f42b9f425c04':
          '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
      },
    },
    adminId: 'client',
    email: 'client@incentivio.com',
    clientID: '1b63163d-1aba-4944-bbc1-ebc495d9dc5c',
    firstName: 'Client',
    lastName: 'User',
    merchantId: null,
    role: {
      id: 1,
      role: 'Incentivio Master Administrator',
      description: 'Admin Full Access (same name as on production)',
      modules: [
        {
          id: 35,
          name: 'Survey',
          description: 'Survey',
          order: 9,
          roleModulePermissions: [
            {
              id: 90,
              permission: 'DELETE_SURVEY',
              description: 'Delete Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
            {
              id: 91,
              permission: 'CREATE_SURVEY',
              description: 'Create Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
            {
              id: 88,
              permission: 'VIEW_SURVEY',
              description: 'View Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
            {
              id: 89,
              permission: 'EDIT_SURVEY',
              description: 'Edit Survey',
              moduleID: 35,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 37,
          name: 'Customers',
          description: 'Customers',
          order: 11,
          roleModulePermissions: [
            {
              id: 128,
              permission: 'MANAGE_CUSTOMER_SPECIAL_TAGS',
              description: 'Manage Special Tags (Incentivio only)',
              moduleID: 37,
              deleted: false,
              active: true,
            },
            {
              id: 96,
              permission: 'VIEW_CUSTOMER',
              description: 'View Customer',
              moduleID: 37,
              deleted: false,
              active: true,
            },
            {
              id: 149,
              permission: 'DELETE_CUSTOMER',
              description: 'Delete a customer account',
              moduleID: 37,
              deleted: false,
              active: true,
            },
            {
              id: 134,
              permission: 'EDIT_CUSTOMER',
              description: 'Edit Customer',
              moduleID: 37,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 27,
          name: 'Roles',
          description: 'Roles',
          order: 24,
          roleModulePermissions: [
            {
              id: 49,
              permission: 'EDIT_ROLE',
              description: 'Edit Role',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 47,
              permission: 'CREATE_ROLE',
              description: 'Create Role',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 48,
              permission: 'VIEW_ROLE',
              description: 'View Roles',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 145,
              permission: 'MANAGE_ROLE_INCENTIVIO',
              description: 'Manage Incentivio roles',
              moduleID: 27,
              deleted: false,
              active: true,
            },
            {
              id: 50,
              permission: 'DELETE_ROLE',
              description: 'Delete Role',
              moduleID: 27,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 9,
          name: 'Analytics',
          description: 'Analytics',
          order: 1,
          roleModulePermissions: [
            {
              id: 150,
              permission: 'VIEW_SALES_SUMMARY',
              description: 'View Sales Summary',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 19,
              permission: 'VIEW_DASHBOARD',
              description: 'View Dashboard',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 129,
              permission: 'VIEW_RECOMMENDATIONS',
              description: 'View Recommendations',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 76,
              permission: 'VIEW_DAILY_ORDERS_REPORT',
              description: 'View Daily Sales Report',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 75,
              permission: 'VIEW_ORDERS',
              description: 'View Orders',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 130,
              permission: 'VIEW_GUEST_JOURNEY',
              description: 'View Guest Journey',
              moduleID: 9,
              deleted: false,
              active: true,
            },
            {
              id: 169,
              permission: 'EDIT_GUEST_JOURNEY_SETTINGS',
              description: 'Edit Guest Journey Settings',
              moduleID: 9,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 24,
          name: 'Group',
          description: 'Group',
          order: 21,
          roleModulePermissions: [
            {
              id: 64,
              permission: 'VIEW_GROUP',
              description: 'View Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
            {
              id: 65,
              permission: 'EDIT_GROUP',
              description: 'Edit Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
            {
              id: 66,
              permission: 'DELETE_GROUP',
              description: 'Delete Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
            {
              id: 63,
              permission: 'CREATE_GROUP',
              description: 'Create Group',
              moduleID: 24,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 13,
          name: 'Offers',
          description: 'Offers',
          order: 3,
          roleModulePermissions: [
            {
              id: 9,
              permission: 'DELETE_OFFER',
              description: 'Delete Offer',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 6,
              permission: 'VIEW_OFFER',
              description: 'View Offers',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 5,
              permission: 'CREATE_OFFER',
              description: 'Create Offer',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 8,
              permission: 'DISTRIBUTE_OFFERS',
              description: 'Distribute Offers',
              moduleID: 13,
              deleted: false,
              active: true,
            },
            {
              id: 7,
              permission: 'EDIT_OFFER',
              description: 'Edit Offer',
              moduleID: 13,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 38,
          name: 'Easy Order',
          description: 'Easy Order',
          order: 19,
          roleModulePermissions: [
            {
              id: 101,
              permission: 'DELETE_EASY_ORDER',
              description: 'Delete Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
            {
              id: 99,
              permission: 'VIEW_EASY_ORDER',
              description: 'View Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
            {
              id: 102,
              permission: 'CREATE_EASY_ORDER',
              description: 'Create Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
            {
              id: 100,
              permission: 'EDIT_EASY_ORDER',
              description: 'Edit Easy Order',
              moduleID: 38,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 43,
          name: 'Captcha',
          description: 'Captcha',
          order: 0,
          roleModulePermissions: [
            {
              id: 132,
              permission: 'ENABLE_CAPTCHA',
              description: 'Enable Captcha',
              moduleID: 43,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 39,
          name: 'Promo Code',
          description: 'Promo Code',
          order: 28,
          roleModulePermissions: [
            {
              id: 106,
              permission: 'DELETE_PROMO_CODE',
              description: 'Delete Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
            {
              id: 105,
              permission: 'VIEW_PROMO_CODE',
              description: 'View Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
            {
              id: 104,
              permission: 'EDIT_PROMO_CODE',
              description: 'Edit Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
            {
              id: 103,
              permission: 'CREATE_PROMO_CODE',
              description: 'Create Promo Code',
              moduleID: 39,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 40,
          name: 'Gift Card',
          description: 'Gift Card',
          order: 29,
          roleModulePermissions: [
            {
              id: 114,
              permission: 'IMPORT_GIFT_CARDS',
              description: 'Import Gift Cards',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 115,
              permission: 'GENERATE_GIFT_CARDS',
              description: 'Generate Gift Cards',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 117,
              permission: 'VIEW_GIFT_CARD_POOL_REPORT',
              description: 'View Gift Card Pool Report',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 113,
              permission: 'DEACTIVATE_GIFT_CARD',
              description: 'Deactivate Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 111,
              permission: 'RESET_BALANCE_GIFT_CARD',
              description: 'Reset Gift Card Balance',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 110,
              permission: 'REMOVE_VALUE_GIFT_CARD',
              description: 'Remove Value From Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 112,
              permission: 'ACTIVATE_GIFT_CARD',
              description: 'Activate Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 119,
              permission: 'COMP_ADD_VALUE_GIFT_CARD',
              description: 'Comp Add Value',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 116,
              permission: 'VIEW_GIFT_ANALYTICS',
              description: 'View Gift Analytics',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 118,
              permission: 'RESEND_GIFT_CARD_EMAIL',
              description: 'Resend Gift Card Email',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 109,
              permission: 'VIEW_GIFT_CARD',
              description: 'View Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
            {
              id: 120,
              permission: 'COMP_GIFT_CARD',
              description: 'Comp Gift Card',
              moduleID: 40,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 36,
          name: 'Survey Question',
          description: 'Survey Question',
          order: 10,
          roleModulePermissions: [
            {
              id: 94,
              permission: 'DELETE_SURVEY_QUESTION',
              description: 'Delete Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
            {
              id: 95,
              permission: 'CREATE_SURVEY_QUESTION',
              description: 'Create Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
            {
              id: 93,
              permission: 'EDIT_SURVEY_QUESTION',
              description: 'Edit Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
            {
              id: 92,
              permission: 'VIEW_SURVEY_QUESTION',
              description: 'View Survey Question',
              moduleID: 36,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 11,
          name: 'Campaign',
          description: 'Campaign',
          order: 2,
          roleModulePermissions: [
            {
              id: 15,
              permission: 'CREATE_CAMPAIGN',
              description: 'Create Campaign',
              moduleID: 11,
              deleted: false,
              active: true,
            },
            {
              id: 18,
              permission: 'DELETE_CAMPAIGN',
              description: 'Delete Campaign',
              moduleID: 11,
              deleted: false,
              active: true,
            },
            {
              id: 16,
              permission: 'VIEW_CAMPAIGN',
              description: 'View Campaigns',
              moduleID: 11,
              deleted: false,
              active: true,
            },
            {
              id: 17,
              permission: 'EDIT_CAMPAIGN',
              description: 'Edit Campaign',
              moduleID: 11,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 19,
          name: 'Store',
          description: 'Store',
          order: 12,
          roleModulePermissions: [
            {
              id: 26,
              permission: 'EDIT_STORE',
              description: 'Edit Store',
              moduleID: 19,
              deleted: false,
              active: true,
            },
            {
              id: 25,
              permission: 'VIEW_STORE',
              description: 'View Stores',
              moduleID: 19,
              deleted: false,
              active: true,
            },
            {
              id: 27,
              permission: 'DELETE_STORE',
              description: 'Delete Store',
              moduleID: 19,
              deleted: false,
              active: true,
            },
            {
              id: 24,
              permission: 'CREATE_STORE',
              description: 'Create Store',
              moduleID: 19,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 32,
          name: 'Store Ordering Setup',
          description: 'Store Ordering Setup',
          order: 13,
          roleModulePermissions: [
            {
              id: 81,
              permission: 'EDIT_STORE_ORDERING',
              description: 'Edit Store Ordering',
              moduleID: 32,
              deleted: false,
              active: true,
            },
            {
              id: 80,
              permission: 'VIEW_STORE_ORDERING',
              description: 'View Store Ordering',
              moduleID: 32,
              deleted: false,
              active: true,
            },
            {
              id: 82,
              permission: 'DELETE_STORE_ORDERING',
              description: 'Delete Store Ordering',
              moduleID: 32,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 45,
          name: 'Auto Tagger',
          description: 'Auto Tagger',
          order: 32,
          roleModulePermissions: [
            {
              id: 142,
              permission: 'UPDATE_SEGMENT',
              description: 'Update segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
            {
              id: 140,
              permission: 'VIEW_SEGMENT',
              description: 'View segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
            {
              id: 141,
              permission: 'CREATE_SEGMENT',
              description: 'Create segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
            {
              id: 143,
              permission: 'DELETE_SEGMENT',
              description: 'Delete segment',
              moduleID: 45,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 15,
          name: 'Persona',
          description: 'Persona',
          order: 6,
          roleModulePermissions: [
            {
              id: 57,
              permission: 'EDIT_PERSONA',
              description: 'Edit Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
            {
              id: 58,
              permission: 'DELETE_PERSONA',
              description: 'Delete Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
            {
              id: 56,
              permission: 'VIEW_PERSONA',
              description: 'View Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
            {
              id: 55,
              permission: 'CREATE_PERSONA',
              description: 'Create Persona',
              moduleID: 15,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 21,
          name: 'Category',
          description: 'Category',
          order: 15,
          roleModulePermissions: [
            {
              id: 39,
              permission: 'DELETE_CATEGORY',
              description: 'Delete Category',
              moduleID: 21,
              deleted: false,
              active: true,
            },
            {
              id: 38,
              permission: 'EDIT_CATEGORY',
              description: 'Edit Category',
              moduleID: 21,
              deleted: false,
              active: true,
            },
            {
              id: 37,
              permission: 'VIEW_CATEGORY',
              description: 'View Categories',
              moduleID: 21,
              deleted: false,
              active: true,
            },
            {
              id: 36,
              permission: 'CREATE_CATEGORY',
              description: 'Create Category',
              moduleID: 21,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 25,
          name: 'Item',
          description: 'Item',
          order: 22,
          roleModulePermissions: [
            {
              id: 72,
              permission: 'VIEW_ITEM',
              description: 'View Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
            {
              id: 71,
              permission: 'CREATE_ITEM',
              description: 'Create Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
            {
              id: 73,
              permission: 'EDIT_ITEM',
              description: 'Edit Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
            {
              id: 74,
              permission: 'DELETE_ITEM',
              description: 'Delete Item',
              moduleID: 25,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 31,
          name: 'Merchant Ordering Setup',
          description: 'Merchant Ordering Setup',
          order: 8,
          roleModulePermissions: [
            {
              id: 77,
              permission: 'VIEW_MERCHANT_ORDERING',
              description: 'View Merchant Ordering',
              moduleID: 31,
              deleted: false,
              active: true,
            },
            {
              id: 79,
              permission: 'DELETE_MERCHANT_ORDERING',
              description: 'Delete Merchant Ordering',
              moduleID: 31,
              deleted: false,
              active: true,
            },
            {
              id: 78,
              permission: 'EDIT_MERCHANT_ORDERING',
              description: 'Edit Merchant Ordering',
              moduleID: 31,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 41,
          name: 'Menu Import',
          description: 'Menu Import',
          order: 30,
          roleModulePermissions: [
            {
              id: 123,
              permission: 'MENU_IMPORT_FOR_SINGLE_LOCATION',
              description: 'Menu Import for Single Location',
              moduleID: 41,
              deleted: false,
              active: true,
            },
            {
              id: 122,
              permission: 'MENU_IMPORT_FOR_LOCATIONS',
              description: 'Menu Import for Locations',
              moduleID: 41,
              deleted: false,
              active: true,
            },
            {
              id: 121,
              permission: 'VIEW_MENU_IMPORT_HISTORY',
              description: 'View Menu Import History',
              moduleID: 41,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 10,
          name: 'Program',
          description: 'Program',
          order: 2,
          roleModulePermissions: [
            {
              id: 31,
              permission: 'DELETE_PROGRAM',
              description: 'Delete Program',
              moduleID: 10,
              deleted: false,
              active: true,
            },
            {
              id: 30,
              permission: 'EDIT_PROGRAM',
              description: 'Edit Program',
              moduleID: 10,
              deleted: false,
              active: true,
            },
            {
              id: 29,
              permission: 'VIEW_PROGRAM',
              description: 'View Programs',
              moduleID: 10,
              deleted: false,
              active: true,
            },
            {
              id: 28,
              permission: 'CREATE_PROGRAM',
              description: 'Create Program',
              moduleID: 10,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 42,
          name: 'ACH Portal',
          description: 'ACH Portal',
          order: 31,
          roleModulePermissions: [
            {
              id: 126,
              permission: 'ACH_PORTAL_ENROLL_LOCATION',
              description: 'ACH Portal Enroll Location',
              moduleID: 42,
              deleted: false,
              active: true,
            },
            {
              id: 124,
              permission: 'ACH_PORTAL_ACCESS',
              description: 'ACH Portal Access',
              moduleID: 42,
              deleted: false,
              active: true,
            },
            {
              id: 125,
              permission: 'ACH_PORTAL_VIEW_POOL_ACCOUNT',
              description: 'ACH Portal View Pool Account',
              moduleID: 42,
              deleted: false,
              active: true,
            },
            {
              id: 127,
              permission: 'ACH_PORTAL_VIEW_TRANSACTION_HISTORY',
              description: 'ACH Portal View Transaction History',
              moduleID: 42,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 14,
          name: 'Loyalty',
          description: 'Loyalty',
          order: 4,
          roleModulePermissions: [
            {
              id: 12,
              permission: 'EDIT_LOYALTY_OFFER',
              description: 'Edit Loyalty Offer',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 13,
              permission: 'DISTRIBUTE_LOYALTY_OFFERS',
              description: 'Distribute Loyalty Offers',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 10,
              permission: 'CREATE_LOYALTY_OFFER',
              description: 'Create Loyalty Offer',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 14,
              permission: 'DELETE_LOYALTY_OFFER',
              description: 'Delete Offer',
              moduleID: 14,
              deleted: false,
              active: true,
            },
            {
              id: 11,
              permission: 'VIEW_LOYALTY_OFFER',
              description: 'View Loyalty Offers',
              moduleID: 14,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 17,
          name: 'Merchant',
          description: 'Merchant',
          order: 7,
          roleModulePermissions: [
            {
              id: 23,
              permission: 'DELETE_MERCHANT',
              description: 'Delete Merchant',
              moduleID: 17,
              deleted: false,
              active: true,
            },
            {
              id: 21,
              permission: 'VIEW_MERCHANT',
              description: 'View Merchants',
              moduleID: 17,
              deleted: false,
              active: true,
            },
            {
              id: 22,
              permission: 'EDIT_MERCHANT',
              description: 'Edit Merchant',
              moduleID: 17,
              deleted: false,
              active: true,
            },
            {
              id: 20,
              permission: 'CREATE_MERCHANT',
              description: 'Create Merchant',
              moduleID: 17,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 22,
          name: 'Brand',
          description: 'Brand',
          order: 17,
          roleModulePermissions: [
            {
              id: 33,
              permission: 'VIEW_BRAND',
              description: 'View Brands',
              moduleID: 22,
              deleted: false,
              active: true,
            },
            {
              id: 34,
              permission: 'EDIT_BRAND',
              description: 'Edit Brand',
              moduleID: 22,
              deleted: false,
              active: true,
            },
            {
              id: 32,
              permission: 'CREATE_BRAND',
              description: 'Create Brand',
              moduleID: 22,
              deleted: false,
              active: true,
            },
            {
              id: 35,
              permission: 'DELETE_BRAND',
              description: 'Delete Brand',
              moduleID: 22,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 34,
          name: 'Support',
          description: 'Support',
          order: 27,
          roleModulePermissions: [
            {
              id: 87,
              permission: 'VIEW_SUPPORT',
              description: 'View Support',
              moduleID: 34,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 44,
          name: 'Payments',
          description: 'Payments',
          order: 31,
          roleModulePermissions: [
            {
              id: 146,
              permission: 'MANAGE_PAYMENTS_INCENTIVIO',
              description: 'Manage Incentivio payments',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 137,
              permission: 'VIEW_TRANSACTIONS',
              description: 'View Payment Transactions',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 136,
              permission: 'CREATE_ACCOUNTS',
              description: 'Create payment accounts',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 139,
              permission: 'VIEW_REPORTS',
              description: 'View payment reports',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 133,
              permission: 'REFUND_ORDERS',
              description: 'Refund Orders',
              moduleID: 44,
              deleted: false,
              active: true,
            },
            {
              id: 135,
              permission: 'VIEW_ACCOUNTS',
              description: 'View payment accounts',
              moduleID: 44,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 33,
          name: 'Customer Tags',
          description: 'Customer Tags',
          order: 18,
          roleModulePermissions: [
            {
              id: 83,
              permission: 'VIEW_EXTENSIBLE_ATTRIBUTES',
              description: 'View Customer Tags',
              moduleID: 33,
              deleted: false,
              active: true,
            },
            {
              id: 85,
              permission: 'EDIT_EXTENSIBLE_ATTRIBUTES',
              description: 'Edit Customer Tags',
              moduleID: 33,
              deleted: false,
              active: true,
            },
            {
              id: 86,
              permission: 'DELETE_EXTENSIBLE_ATTRIBUTES',
              description: 'Delete Customer Tags',
              moduleID: 33,
              deleted: false,
              active: true,
            },
            {
              id: 84,
              permission: 'CREATE_EXTENSIBLE_ATTRIBUTES',
              description: 'Create Customer Tags',
              moduleID: 33,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 16,
          name: 'Beacon',
          description: 'Beacon',
          order: 6,
          roleModulePermissions: [
            {
              id: 53,
              permission: 'DELETE_BEACON',
              description: 'Delete Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
            {
              id: 51,
              permission: 'CREATE_BEACON',
              description: 'Create Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
            {
              id: 54,
              permission: 'VIEW_BEACON',
              description: 'View Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
            {
              id: 52,
              permission: 'EDIT_BEACON',
              description: 'Edit Beacon',
              moduleID: 16,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 29,
          name: 'Loyalty Transaction',
          description: 'Loyalty Transaction',
          order: 26,
          roleModulePermissions: [
            {
              id: 42,
              permission: 'DELETE_LOYALTY_TRANSACTION',
              description: 'Delete Loyalty Transaction',
              moduleID: 29,
              deleted: false,
              active: true,
            },
            {
              id: 40,
              permission: 'VIEW_LOYALTY_TRANSACTION',
              description: 'View Loyalty Transactions',
              moduleID: 29,
              deleted: false,
              active: true,
            },
            {
              id: 41,
              permission: 'EDIT_LOYALTY_TRANSACTION',
              description: 'Edit Loyalty Transaction',
              moduleID: 29,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 26,
          name: 'Users',
          description: 'Users',
          order: 23,
          roleModulePermissions: [
            {
              id: 144,
              permission: 'MANAGE_USER_INCENTIVIO',
              description: 'Manage Incentivio users',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 45,
              permission: 'EDIT_USER',
              description: 'Edit User',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 46,
              permission: 'DELETE_USER',
              description: 'Delete User',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 43,
              permission: 'CREATE_USER',
              description: 'Create User',
              moduleID: 26,
              deleted: false,
              active: true,
            },
            {
              id: 44,
              permission: 'VIEW_USER',
              description: 'View Users',
              moduleID: 26,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 23,
          name: 'Menu',
          description: 'Menu',
          order: 20,
          roleModulePermissions: [
            {
              id: 107,
              permission: 'MENU_BUILDER',
              description: 'Menu Builder',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 147,
              permission: 'VIEW_BULK_IMAGE_UPLOADS',
              description: 'View bulk image uploads',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 62,
              permission: 'DELETE_MENU',
              description: 'Delete Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 148,
              permission: 'CREATE_BULK_IMAGE_UPLOADS',
              description: 'Create bulk image uploads',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 59,
              permission: 'CREATE_MENU',
              description: 'Create Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 108,
              permission: 'CACHE_MENU',
              description: 'Cache Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 60,
              permission: 'VIEW_MENU',
              description: 'View Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
            {
              id: 61,
              permission: 'EDIT_MENU',
              description: 'Edit Menu',
              moduleID: 23,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
        {
          id: 12,
          name: 'Messages',
          description: 'Messages',
          order: 3,
          roleModulePermissions: [
            {
              id: 3,
              permission: 'EDIT_MESSAGE',
              description: 'Edit Message',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 1,
              permission: 'CREATE_MESSAGE',
              description: 'Create Message',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 4,
              permission: 'DELETE_MESSAGE',
              description: 'Delete Message',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 131,
              permission: 'CONFIGURE_CLIENT',
              description: 'Configure Client (Incentivio only)',
              moduleID: 12,
              deleted: false,
              active: true,
            },
            {
              id: 2,
              permission: 'VIEW_MESSAGE',
              description: 'View Messages',
              moduleID: 12,
              deleted: false,
              active: true,
            },
          ],
          allPermissions: null,
          deleted: false,
          active: true,
        },
      ],
      deleted: false,
      active: true,
    },
    status: 'VERIFIED',
    deleted: false,
    storeIds: ['3831ddf4-fa61-4eef-971c-f42b9f425c04'],
    reach:
      '["1b63163d-1aba-4944-bbc1-ebc495d9dc5c;238f878f-fe74-4e41-a838-0f799bc58662;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;73c25df9-b8d5-4d89-9944-dbbdc0c8a117;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;84ace984-71ec-4488-b7fd-cb7bc24a881c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;7f3ffb13-7c1c-4909-9efb-b067b1728f12;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;9458ce51-e44a-451a-b8a3-beb15d1ddbaf;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;392eca08-00c7-4f81-ae98-f346a54fb867;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;4c4ade61-7973-46f0-820f-4bf5bc783e0c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;0d18d2b3-7de0-4e16-b68e-f28a92bb8737;*"]',
    hasEntireClientReach: false,
  },
};

export const superAdminUser = merge(
  {},
  users['abb87f82-b83c-4c57-8e2e-f51c08fa9cec'],
  {
    adminAccountAuthorization: {
      all: true,
    },
    isSuperAdmin: true,
    isClientAdmin: false,
    isWorkspaceAdmin: false,
  },
);

export const clientAdminUser = merge(
  {},
  users['abb87f82-b83c-4c57-8e2e-f51c08fa9cec'],
  {
    adminAccountAuthorization: {
      all: false,
      clients: baseAdminAccountAuthorization.clients.map(client => ({
        ...client,
        all: true,
      })),
    },
    isSuperAdmin: false,
    isClientAdmin: true,
    isWorkspaceAdmin: false,
  },
);

export const workspaceAdminUser = merge(
  {},
  users['abb87f82-b83c-4c57-8e2e-f51c08fa9cec'],
  {
    adminAccountAuthorization: {
      all: false,
      clients: baseAdminAccountAuthorization.clients.map(client => ({
        ...client,
        all: true,
        locations: client.merchants.map(merchant => ({
          ...merchant,
          all: true,
        })),
      })),
    },
    isSuperAdmin: false,
    isClientAdmin: false,
    isWorkspaceAdmin: true,
  },
);

export const limitedAccessUser = merge(
  {},
  users['abb87f82-b83c-4c57-8e2e-f51c08fa9cec'],
  {
    adminAccountAuthorization: {
      all: false,
      clients: baseAdminAccountAuthorization.clients.map(client => ({
        ...client,
        all: false,
        merchants: client.merchants.map(merchant => ({
          ...merchant,
          all: false,
          locations: [{ id: 'id0' }],
        })),
      })),
    },
    isSuperAdmin: false,
    isClientAdmin: false,
    isWorkspaceAdmin: false,
  },
);
